
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("k9zbN", function(module, exports) {
$parcel$export(module.exports, "GlobalCreateContentPopover", () => (parcelRequire("aQZ08")).GlobalCreateContentPopover);
$parcel$export(module.exports, "GlobalCreateContentPopoverSpotlightLoader", () => (parcelRequire("eTign")).GlobalCreateContentPopoverSpotlightLoader);
$parcel$export(module.exports, "GlobalCreateContentButton", () => (parcelRequire("gsXbX")).GlobalCreateContentButton);
$parcel$export(module.exports, "ContextualCreateContentPopover", () => (parcelRequire("2to2n")).ContextualCreateContentPopover);
$parcel$export(module.exports, "contextualCreateContentIconSVGColor", () => (parcelRequire("cDCEW")).contextualCreateContentIconSVGColor);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $aQZ08 = parcelRequire("aQZ08");


var $eTign = parcelRequire("eTign");


var $gsXbX = parcelRequire("gsXbX");


var $2to2n = parcelRequire("2to2n");


var $cDCEW = parcelRequire("cDCEW");


});

parcelRegister("aQZ08", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $5izcQ = parcelRequire("5izcQ");


var $jmjWc = parcelRequire("jmjWc");


var $56QzY = parcelRequire("56QzY");


var $7zgzO = parcelRequire("7zgzO");


var $de2j9 = parcelRequire("de2j9");


var $ep3mz = parcelRequire("ep3mz");


var $gz8ZY = parcelRequire("gz8ZY");


var $7EIq6 = parcelRequire("7EIq6");


var $gsXbX = parcelRequire("gsXbX");

const $dc1ea4817175b6dd$export$e961788b96f97626 = ()=>{
    const $ = (0, $frIzR.c)(19);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isNav4Enabled || $[2] !== isOnEditRoute || $[3] !== isOpen || $[4] !== match?.name) {
        t0 = ()=>{
            setIsOpen(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "globalCreateContentPopover",
                    source: "globalNavigation",
                    attributes: {
                        selectedItemPageContext: match?.name,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: isNav4Enabled ? "4" : "3",
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isNav4Enabled;
        $[2] = isOnEditRoute;
        $[3] = isOpen;
        $[4] = match?.name;
        $[5] = t0;
    } else t0 = $[5];
    const onClick = t0;
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    let t1;
    if ($[6] !== isCreateBlogEnabled || $[7] !== isCreateDatabaseEnabled || $[8] !== isCreateLiveDocEnabled || $[9] !== isCreateSmartLinkEnabled || $[10] !== isCreateWhiteboardEnabled) {
        t1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($dc1ea4817175b6dd$var$GlobalCreateContentPopoverMenuLoader, {
                closePopup: ()=>setIsOpen(false),
                isCreateBlogEnabled: isCreateBlogEnabled,
                isCreateLiveDocEnabled: isCreateLiveDocEnabled,
                isCreateWhiteboardEnabled: isCreateWhiteboardEnabled,
                isCreateDatabaseEnabled: isCreateDatabaseEnabled,
                isCreateSmartLinkEnabled: isCreateSmartLinkEnabled
            });
        $[6] = isCreateBlogEnabled;
        $[7] = isCreateDatabaseEnabled;
        $[8] = isCreateLiveDocEnabled;
        $[9] = isCreateSmartLinkEnabled;
        $[10] = isCreateWhiteboardEnabled;
        $[11] = t1;
    } else t1 = $[11];
    const popupContent = t1;
    let t2;
    if ($[12] !== onClick) {
        t2 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
                name: "space-types-changeboarding-target"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gsXbX.GlobalCreateContentButton), {
                onClick: onClick,
                triggerProps: triggerProps
            })));
        $[12] = onClick;
        $[13] = t2;
    } else t2 = $[13];
    const popupTrigger = t2;
    let t3;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setIsOpen(false);
        $[14] = t3;
    } else t3 = $[14];
    let t4;
    if ($[15] !== isOpen || $[16] !== popupContent || $[17] !== popupTrigger) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: isOpen,
            onClose: t3,
            placement: "bottom-start",
            content: popupContent,
            trigger: popupTrigger,
            testId: "create-content-popover",
            shouldRenderToParent: true
        });
        $[15] = isOpen;
        $[16] = popupContent;
        $[17] = popupTrigger;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
};

const $dc1ea4817175b6dd$var$GlobalCreateContentPopoverMenuLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "5t0g-",
    name: "GlobalCreateContentPopoverMenuLoader",
    loader: async ()=>(await (parcelRequire("aNW5l"))).GlobalCreateContentPopoverMenu
});
module.exports["GlobalCreateContentPopover"] = $dc1ea4817175b6dd$export$e961788b96f97626;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("gsXbX", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $4rwCt = parcelRequire("4rwCt");


var $4KS7f = parcelRequire("4KS7f");


var $g5gZt = parcelRequire("g5gZt");


var $lBYCH = parcelRequire("lBYCH");


var $gz8ZY = parcelRequire("gz8ZY");


var $jmjWc = parcelRequire("jmjWc");


var $6PMed = parcelRequire("6PMed");


var $lLaRd = parcelRequire("lLaRd");


const $18414c638d573189$var$CreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xnuWz",
    name: "CreateButton",
    loader: async ()=>(await (parcelRequire("kPga6"))).CreateButton
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $18414c638d573189$var$CreateContentButtonTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1nu9 _12wkglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $18414c638d573189$var$i18n = (0, $cgtv4.defineMessages)({
    create: {
        id: "create-blank-fabric-page.create.content.popover.button",
        defaultMessage: "Create"
    },
    createContentLabel: {
        id: "create-blank-fabric-page.create.content.aria.label",
        defaultMessage: "Create content"
    }
});
const $18414c638d573189$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $18414c638d573189$export$dff01287f8ba179f = (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { triggerProps: triggerProps, onClick: onClick } = t0;
    const { ref: ref } = triggerProps;
    const intl = (0, $8C5kA.default)();
    const { theme: theme, createContentPopoverButtonRef: createContentPopoverButtonRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const preloadCreationMenuData = (0, $6PMed.usePreloadCreationMenuData)();
    let t1;
    if ($[0] !== onClick) {
        t1 = ()=>{
            onClick();
        };
        $[0] = onClick;
        $[1] = t1;
    } else t1 = $[1];
    const handleClick = t1;
    let t2;
    if ($[2] !== theme) {
        t2 = theme?.mode?.create ? $18414c638d573189$export$256eebed8e934f30(theme.mode.create) : undefined;
        $[2] = theme;
        $[3] = t2;
    } else t2 = $[3];
    const buttonTheme = t2;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    let t3;
    if ($[4] !== buttonTheme || $[5] !== createContentPopoverButtonRef || $[6] !== handleClick || $[7] !== intl || $[8] !== isNav4Enabled || $[9] !== triggerProps) {
        const createButton = isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18414c638d573189$var$CreateButton, {
            onClick: handleClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $18414c638d573189$var$i18n.create)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            appearance: "primary",
            theme: buttonTheme,
            onClick: handleClick,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLaRd.IconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                spacing: "spacious",
                label: "",
                "data-vc": "global-content-create-button"
            })),
            testId: "create-content-popover-button",
            ...triggerProps,
            "aria-label": intl.formatMessage($18414c638d573189$var$i18n.createContentLabel),
            ref: createContentPopoverButtonRef ? (0, $4rwCt.mergeRefs)([
                triggerProps.ref,
                createContentPopoverButtonRef
            ]) : triggerProps.ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($18414c638d573189$var$CreateContentButtonTextWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $18414c638d573189$var$i18n.create)));
        t3 = ()=>createButton;
        $[4] = buttonTheme;
        $[5] = createContentPopoverButtonRef;
        $[6] = handleClick;
        $[7] = intl;
        $[8] = isNav4Enabled;
        $[9] = triggerProps;
        $[10] = t3;
    } else t3 = $[10];
    const getCreateButton = t3;
    let t4;
    if ($[11] !== getCreateButton) {
        t4 = getCreateButton();
        $[11] = getCreateButton;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== isNav4Enabled || $[14] !== preloadCreationMenuData || $[15] !== ref || $[16] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lLaRd.CreateContentButtonWrapper), {
            "data-vc": "create-content-button-wrapper",
            ref: ref,
            onMouseEnter: preloadCreationMenuData,
            onFocus: preloadCreationMenuData,
            isNav4Enabled: isNav4Enabled
        }, t4);
        $[13] = isNav4Enabled;
        $[14] = preloadCreationMenuData;
        $[15] = ref;
        $[16] = t4;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
};
module.exports["GlobalCreateContentButton"] = $18414c638d573189$export$dff01287f8ba179f;

});

parcelRegister("4rwCt", function(module, exports) {

var $51c7W = parcelRequire("51c7W");


var $JlyMu = parcelRequire("JlyMu");

function $33c2fc9905303660$export$c9058316764c140e(refs) {
    return (0, $JlyMu.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $51c7W.assignRef)(ref, newValue)));
}
module.exports["mergeRefs"] = $33c2fc9905303660$export$c9058316764c140e;

});

parcelRegister("JlyMu", function(module, exports) {
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $0884ed72a8650e84$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}
module.exports["createCallbackRef"] = $0884ed72a8650e84$export$35a19128eb4acba4;

});

parcelRegister("lBYCH", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $1e166e9bfc301d21$export$695e6f0ac03b03ae = (0, $42omo.createContext)({
    isBranchDeploy: false
});
$1e166e9bfc301d21$export$695e6f0ac03b03ae.displayName = 'AppNavigationContext';
module.exports["AppNavigationContext"] = $1e166e9bfc301d21$export$695e6f0ac03b03ae;

});

parcelRegister("6PMed", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $jxs8y = parcelRequire("jxs8y");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $eVXGa = parcelRequire("eVXGa");

const $bd992de7e8ae5757$var$usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery = (0, $eSUdr.default)`query usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:"whiteboard"){deactivationIdentifier link title}}`;
const $bd992de7e8ae5757$export$305839d0d8489bf4 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const [preloadWhiteboardPaywallData] = (0, $jxs8y.useLazyQuery)($bd992de7e8ae5757$var$usePreloadCreationMenuDataWhiteboardCreationPaywallContentToDisableQuery);
    const shouldPreloadPaywallData = isAllowedToCreateWhiteboard && !isPremium;
    return (0, $42omo.useCallback)(()=>{
        if (shouldPreloadPaywallData) preloadWhiteboardPaywallData();
    }, [
        preloadWhiteboardPaywallData,
        shouldPreloadPaywallData
    ]);
};
module.exports["usePreloadCreationMenuData"] = $bd992de7e8ae5757$export$305839d0d8489bf4;

});

parcelRegister("lLaRd", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $35d2916df5304fc4$export$feec4094f6279c08 = 1129;
const $35d2916df5304fc4$export$be58b4326e23250f = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _18u0r5cr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $35d2916df5304fc4$export$bfe3a25e72ae6442 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isNav4Enabled: isNav4Enabled, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1y3ozwfg _1qbpzwfg _7bqgzwfg _9kv71tcg _1i0i1tcg _1f1h1tcg _1n3cidpf _113jidpf _1kzlidpf",
            !__cmplp.isNav4Enabled && "_18u0utpp",
            __cmplp.isNav4Enabled ? "_859hu2gc _1wkzu2gc _bgw9u2gc" : "_859hutpp _1wkzutpp _bgw9utpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["IconWrapper"] = $35d2916df5304fc4$export$be58b4326e23250f;
module.exports["CreateContentButtonWrapper"] = $35d2916df5304fc4$export$bfe3a25e72ae6442;

});

parcelRegister("kPga6", function(module, exports) {

let $f2951b7e808f1770$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f2951b7e808f1770$var$load("6wr18"),
    $f2951b7e808f1770$var$load("kFEyO"),
    $f2951b7e808f1770$var$load("hLjS5"),
    $f2951b7e808f1770$var$load("48rvp"),
    $f2951b7e808f1770$var$load("iMSgb"),
    $f2951b7e808f1770$var$load("ffEVr"),
    $f2951b7e808f1770$var$load("7EorR"),
    $f2951b7e808f1770$var$load("hhss7"),
    $f2951b7e808f1770$var$load("dnVDi")
]).then(()=>parcelRequire('ePUmE'));

});

parcelRegister("aNW5l", function(module, exports) {

let $0207ab81fd8fc9b5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0207ab81fd8fc9b5$var$load("6wr18"),
    $0207ab81fd8fc9b5$var$load("7QQL7"),
    $0207ab81fd8fc9b5$var$load("aDPqY"),
    $0207ab81fd8fc9b5$var$load("ffEVr"),
    $0207ab81fd8fc9b5$var$load("7EorR"),
    $0207ab81fd8fc9b5$var$load("GuKfo"),
    $0207ab81fd8fc9b5$var$load("5ZwKh"),
    $0207ab81fd8fc9b5$var$load("dwffN")
]).then(()=>parcelRequire('bvmt1'));

});

parcelRegister("eTign", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $5RBJ9 = parcelRequire("5RBJ9");

var $5izcQ = parcelRequire("5izcQ");

var $2Fndw = parcelRequire("2Fndw");


var $jmjWc = parcelRequire("jmjWc");


var $94z7g = parcelRequire("94z7g");


var $aQZ08 = parcelRequire("aQZ08");

const $65cf0976c45402f8$var$i18n = (0, $cgtv4.defineMessages)({
    gaSpotlightBody: {
        id: "create-blank-fabric-page.global-create.ga-spotlight-body",
        defaultMessage: "Create a whiteboard at any time using this button."
    },
    gaSpotlightCloseButton: {
        id: "create-blank-fabric-page.global-create.ga-spotlight-close",
        defaultMessage: "Okay"
    },
    spotlightBody: {
        id: "create-blank-fabric-page.global-create.spotlight-body",
        defaultMessage: "Create whiteboards from wherever you are in Confluence, whenever inspiration strikes."
    },
    spotlightCloseButton: {
        id: "create-blank-fabric-page.global-create.spotlight-close",
        defaultMessage: "Got it"
    }
});
const $65cf0976c45402f8$export$6965f847afddc834 = (t0)=>{
    const $ = (0, $frIzR.c)(21);
    const { isGA: isGA, isUniversalCreate: t1, spotlightEnabled: spotlightEnabled, onSpotlightClose: onSpotlightClose } = t0;
    const isUniversalCreate = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== isGA || $[2] !== onSpotlightClose) {
        t2 = ()=>{
            onSpotlightClose();
            if (isGA) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "closeWhiteboardGAOnboardingSpotlight",
                    source: "globalCreateSpotlight"
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isGA;
        $[2] = onSpotlightClose;
        $[3] = t2;
    } else t2 = $[3];
    const onClose = t2;
    let t3;
    let t4;
    if ($[4] !== createAnalyticsEvent || $[5] !== isGA || $[6] !== spotlightEnabled) {
        t3 = ()=>{
            if (spotlightEnabled && isGA) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "globalCreateWBSpotlightScreen",
                    attributes: {
                        boardType: "ga-onboarding"
                    },
                    source: "globalNavigation"
                }
            }).fire();
        };
        t4 = [
            createAnalyticsEvent,
            isGA,
            spotlightEnabled
        ];
        $[4] = createAnalyticsEvent;
        $[5] = isGA;
        $[6] = spotlightEnabled;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[9] !== isUniversalCreate) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
            name: "nav-create-whiteboard-onboarding"
        }, isUniversalCreate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94z7g.UniversalCreate), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aQZ08.GlobalCreateContentPopover), null));
        $[9] = isUniversalCreate;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== formatMessage || $[12] !== isGA || $[13] !== onClose || $[14] !== spotlightEnabled) {
        t6 = spotlightEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5RBJ9.default), {
            dialogWidth: 287,
            targetRadius: 3,
            actions: [
                {
                    onClick: onClose,
                    text: formatMessage(isGA ? $65cf0976c45402f8$var$i18n.gaSpotlightCloseButton : $65cf0976c45402f8$var$i18n.spotlightCloseButton)
                }
            ],
            target: "nav-create-whiteboard-onboarding",
            key: "nav-create-whiteboard-onboarding"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), isGA ? $65cf0976c45402f8$var$i18n.gaSpotlightBody : $65cf0976c45402f8$var$i18n.spotlightBody));
        $[11] = formatMessage;
        $[12] = isGA;
        $[13] = onClose;
        $[14] = spotlightEnabled;
        $[15] = t6;
    } else t6 = $[15];
    let t7;
    if ($[16] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Fndw.default), null, t6);
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== t5 || $[19] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, t7);
        $[18] = t5;
        $[19] = t7;
        $[20] = t8;
    } else t8 = $[20];
    return t8;
};

const $65cf0976c45402f8$export$57112b45afa4aad9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "3ZtCp",
    name: "GlobalCreateContentPopoverSpotlightLoader",
    loader: async ()=>(await Promise.resolve(module.exports)).GlobalCreateContentPopoverSpotlight
});
module.exports["GlobalCreateContentPopoverSpotlight"] = $65cf0976c45402f8$export$6965f847afddc834;
module.exports["GlobalCreateContentPopoverSpotlightLoader"] = $65cf0976c45402f8$export$57112b45afa4aad9;

});

parcelRegister("94z7g", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $56QzY = parcelRequire("56QzY");


var $lBYCH = parcelRequire("lBYCH");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $jmjWc = parcelRequire("jmjWc");


var $de2j9 = parcelRequire("de2j9");


var $7zgzO = parcelRequire("7zgzO");


var $gz8ZY = parcelRequire("gz8ZY");


var $3J7nf = parcelRequire("3J7nf");


var $3Yga2 = parcelRequire("3Yga2");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7EIq6 = parcelRequire("7EIq6");


var $eB1TF = parcelRequire("eB1TF");


var $6e99h = parcelRequire("6e99h");



const $f44feda85e5453ef$var$UniversalCreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NRUrF",
    name: "UniversalCreateButton",
    loader: async ()=>{
        if ((0, $9wGTI.fg)('navx_uc_confluence_entrypoint_enabled')) {
            const module = await (parcelRequire("2JWbn"));
            return module.UniversalCreateButtonLazy;
        } else {
            const module = await (parcelRequire("3r6hw"));
            return module.default;
        }
    }
});
const $f44feda85e5453ef$var$messages = (0, $cgtv4.defineMessages)({
    create: {
        id: "create-blank-fabric-page.universal-create.create.text",
        defaultMessage: "Create"
    }
});
const $f44feda85e5453ef$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $f44feda85e5453ef$var$Create = (t0)=>{
    const $ = (0, $frIzR.c)(34);
    const { flags: flags } = t0;
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const { setIsOpen: setIsOpen, setOpenFrom: setOpenFrom } = (0, $eB1TF.useUniversalCreateActions)();
    let t1;
    if ($[0] !== setIsOpen) {
        t1 = ()=>setIsOpen(false);
        $[0] = setIsOpen;
        $[1] = t1;
    } else t1 = $[1];
    const items = (0, $6e99h.useMenuItems)(flags, t1);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { theme: theme } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { introSpotlight: t2 } = (0, $3J7nf.useLiveDocChangeboarding)();
    const { isVisible: introSpotlightVisible } = t2;
    const { cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const hasIteratedShownTracker = (0, $42omo.useRef)(false);
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $3Yga2.checkShouldShowLozenge)();
        $[2] = t3;
    } else t3 = $[2];
    const shouldShowLozenge = t3;
    let t4;
    if ($[3] !== theme) {
        t4 = theme?.mode?.create ? $f44feda85e5453ef$export$256eebed8e934f30(theme.mode.create) : undefined;
        $[3] = theme;
        $[4] = t4;
    } else t4 = $[4];
    const buttonTheme = t4;
    let t5;
    if ($[5] !== createAnalyticsEvent || $[6] !== isCreateLiveDocEnabled || $[7] !== isNav4Enabled || $[8] !== isOnEditRoute || $[9] !== isOpen || $[10] !== match?.name || $[11] !== setIsOpen) {
        t5 = ()=>{
            if (!isOpen) {
                if (shouldShowLozenge && isCreateLiveDocEnabled && !hasIteratedShownTracker.current) {
                    (0, $3Yga2.iterateLozengeShownTracker)();
                    hasIteratedShownTracker.current = true;
                }
            }
            setIsOpen(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "globalCreateContentPopover",
                    source: "globalNavigation",
                    attributes: {
                        selectedItemPageContext: match?.name,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: isNav4Enabled ? "4" : "3",
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[5] = createAnalyticsEvent;
        $[6] = isCreateLiveDocEnabled;
        $[7] = isNav4Enabled;
        $[8] = isOnEditRoute;
        $[9] = isOpen;
        $[10] = match?.name;
        $[11] = setIsOpen;
        $[12] = t5;
    } else t5 = $[12];
    match?.name;
    const onCreateClick = t5;
    let t6;
    if ($[13] !== setIsOpen || $[14] !== setOpenFrom) {
        t6 = ()=>{
            setIsOpen(false);
            setOpenFrom("");
        };
        $[13] = setIsOpen;
        $[14] = setOpenFrom;
        $[15] = t6;
    } else t6 = $[15];
    const onClose = t6;
    let t7;
    if ($[16] !== introSpotlightVisible) {
        t7 = introSpotlightVisible && (0, $9wGTI.fg)("cc_modernize_ga_changeboarding");
        $[16] = introSpotlightVisible;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== cloudId || $[19] !== orgId || $[20] !== userId) {
        t8 = (0, $9wGTI.fg)("navx_uc_enable_suggestion_in_confluence") ? {
            enabled: true,
            compact: true,
            prefetch: true,
            cloudId: cloudId || "",
            orgId: orgId || "",
            accountId: userId || ""
        } : {
            enabled: false
        };
        $[18] = cloudId;
        $[19] = orgId;
        $[20] = userId;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== formatMessage) {
        t9 = formatMessage($f44feda85e5453ef$var$messages.create);
        $[22] = formatMessage;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== buttonTheme || $[25] !== isNav4Enabled || $[26] !== isOpen || $[27] !== items || $[28] !== onClose || $[29] !== onCreateClick || $[30] !== t7 || $[31] !== t8 || $[32] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f44feda85e5453ef$var$UniversalCreateButton, {
            items: items,
            onClick: onCreateClick,
            triggerButtonSpotlightTarget: "top-nav-create",
            enableTriggerPulse: false,
            isNav4Enabled: isNav4Enabled,
            isOpen: isOpen,
            onClose: onClose,
            product: "confluence",
            buttonTheme: buttonTheme,
            testId: "create-content-popover-button",
            preventClose: t7,
            suggestionConfig: t8,
            shouldRenderToParent: true
        }, t9);
        $[24] = buttonTheme;
        $[25] = isNav4Enabled;
        $[26] = isOpen;
        $[27] = items;
        $[28] = onClose;
        $[29] = onCreateClick;
        $[30] = t7;
        $[31] = t8;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    return t10;
};
const $f44feda85e5453ef$var$CreateWithFlags = (0, $7aRa9.withFlags)($f44feda85e5453ef$var$Create);
function $f44feda85e5453ef$export$b8b0dfc3e3d56c92() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NAVX
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f44feda85e5453ef$var$CreateWithFlags, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}
module.exports["UniversalCreate"] = $f44feda85e5453ef$export$b8b0dfc3e3d56c92;

});

parcelRegister("3J7nf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $ivb8S = parcelRequire("ivb8S");


var $gTyTP = parcelRequire("gTyTP");


var $3jwuS = parcelRequire("3jwuS");


var $8Lx5S = parcelRequire("8Lx5S");


var $1zBOs = parcelRequire("1zBOs");


var $bPDOf = parcelRequire("bPDOf");

var $9DBk6 = parcelRequire("9DBk6");


var $evORK = parcelRequire("evORK");


var $cgSxj = parcelRequire("cgSxj");


var $irr7I = parcelRequire("irr7I");

const $575144cb3db51cc4$export$7e64b0f7c7042443 = {
    introSpotlight: {
        isVisible: false,
        complete: ()=>{}
    },
    liveDocTour: {
        isVisible: false,
        complete: ()=>{}
    },
    contentWrapperTour: {
        isVisible: false,
        complete: ()=>{}
    },
    aiButtonTour: {
        isVisible: false,
        complete: ()=>{}
    }
};
const $575144cb3db51cc4$export$a26d1635f48253f6 = (changeboarding)=>Object.values(changeboarding).some((tour)=>{
        if (typeof tour === 'object' && tour !== null && 'isVisible' in tour) return tour.isVisible;
        return false;
    });
const $575144cb3db51cc4$export$bea8fd520e488fdb = ()=>{
    const [introSpotlightDismissed, setIntroSpotlightDismissed] = (0, $42omo.useState)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { isAIFCOnbardingEligible: isAIFCOnbardingEligible, loading: isAIFCOnbardingEligibleLoading, error: isAIFCOnbardingEligibleError } = (0, $evORK.useIsAIFCOnbardingEligible)();
    const { isEstablishedUser: isEstablishedUser, loading: isEstablishedUserLoading, error: isEstablishedUserError } = (0, $1zBOs.useIsEstablishedUser)({
        skip: !(0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap')
    });
    const { data: data, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS)),
        ...Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
    ], !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && !(0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap'));
    const { hasDismissedIntroSpotlight: hasDismissedIntroSpotlight, hasDismissedLiveDocTour: hasDismissedLiveDocTour, hasSeenAIFCSpotlight: hasSeenAIFCSpotlight, isAIFCSpotlightActive: isAIFCSpotlightActive } = (0, $ivb8S.deserializeState)(data);
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const isLivePagesAvailableInSpace = (0, $cgSxj.useIsLivePagesAvailableInSpace)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // AIFC onboarding is showing if the user is eligible and has not seen the spotlight or the spotlight is active
    const isAIFCOnboardingShowing = isAIFCOnbardingEligible && (!hasSeenAIFCSpotlight || isAIFCSpotlightActive);
    const introSpotlightBaseCase = !isAIFCOnboardingShowing && !introSpotlightDismissed && isLivePagesFeatureEnabled && !hasDismissedLiveDocTour && !hasDismissedIntroSpotlight && isLivePagesAvailableInSpace && !isLivePage && (isLicensed || isGuest);
    const showIntroSpotlight = introSpotlightBaseCase && !(0, $9wGTI.fg)('cc_modernize_ga_changeboarding') && (0, $9wGTI.fg)('cc_onboarding_changeboarding_for_live_pages_eap');
    const showGAIntroSpotlight = introSpotlightBaseCase && (0, $9wGTI.fg)('cc_modernize_ga_changeboarding');
    const showAiButtonTour = false;
    const { isUserEnrolledInNav4Changeboarding: isUserEnrolledInNav4Changeboarding, isUserCompletedNav4Changeboarding: isUserCompletedNav4Changeboarding, loading: nav4Loading, error: nav4Error } = (0, $irr7I.useIsNav4Changeboarding)();
    const completeIntroSpotlight = (0, $42omo.useCallback)(()=>{
        setIntroSpotlightDismissed(true);
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedIntroSpotlight,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    const completeLiveDocTour = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedLiveDocTour,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    const completeAiButtonTour = (0, $42omo.useCallback)(()=>{
        setOnboardingState({
            key: (0, $9DBk6.LIVE_DOC_CHANGEBOARDING_ONBOARDING_STATE_KEYS).hasDismissedAiButtonTour,
            value: 'true'
        });
    }, [
        setOnboardingState
    ]);
    // Skip onboarding for new users if features are enabled, by marking eligible onboarding as complete.
    // If we did not check to see if they were eligible for each onboarding before marking it complete,
    // we would risk marking onboarding complete when the feature is not yet enabled.
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('cc_modernize_ga_changeboarding')) return;
        if (error || loading || isEstablishedUserError || isEstablishedUserLoading || isAIFCOnbardingEligibleLoading || isAIFCOnbardingEligibleError) return;
        if (!isEstablishedUser) {
            if (showIntroSpotlight) completeIntroSpotlight();
            if (showAiButtonTour) completeAiButtonTour();
        }
    }, [
        isEstablishedUser,
        showIntroSpotlight,
        showAiButtonTour,
        completeAiButtonTour,
        completeIntroSpotlight,
        completeLiveDocTour,
        error,
        isAIFCOnbardingEligibleLoading,
        isAIFCOnbardingEligibleError,
        isEstablishedUserError,
        isEstablishedUserLoading,
        loading
    ]);
    if (error || nav4Error || isAIFCOnbardingEligibleError) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        error: error || nav4Error || isAIFCOnbardingEligibleError
    };
    if (loading || nav4Loading || isEstablishedUserLoading || isAIFCOnbardingEligibleLoading) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        loading: true
    };
    if (showGAIntroSpotlight) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        introSpotlight: {
            isVisible: true,
            complete: completeIntroSpotlight
        }
    };
    // Do not start Live Doc changeboarding until eligible user has completed nav4 changeboarding
    if (isUserEnrolledInNav4Changeboarding && !isUserCompletedNav4Changeboarding) return $575144cb3db51cc4$export$7e64b0f7c7042443;
    if (!isEstablishedUser) return $575144cb3db51cc4$export$7e64b0f7c7042443;
    if (showAiButtonTour) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        aiButtonTour: {
            isVisible: true,
            complete: completeAiButtonTour
        }
    };
    if (showIntroSpotlight) return {
        ...$575144cb3db51cc4$export$7e64b0f7c7042443,
        introSpotlight: {
            isVisible: true,
            complete: completeIntroSpotlight
        }
    };
    return $575144cb3db51cc4$export$7e64b0f7c7042443;
};
module.exports["isLiveDocChangeboardingActive"] = $575144cb3db51cc4$export$a26d1635f48253f6;
module.exports["useLiveDocChangeboarding"] = $575144cb3db51cc4$export$bea8fd520e488fdb;

});

parcelRegister("1zBOs", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $2FNNv = parcelRequire("2FNNv");


var $30D0J = parcelRequire("30D0J");

const $e4b48658f7bfd739$export$fbded7f0a0c86e5e = ({ skip: skip })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isEstablishedUserTraitName = (0, $2FNNv.useIsEstablishedUserTraitName)();
    const { data: data, loading: loading, error: error } = (0, $30D0J.useExperimentalUserPersonalizationQuery)({
        skip: skip || !userId,
        variables: {
            userId: userId ?? ''
        }
    });
    const isEstablishedUser = Boolean(data?.experimentalUserPersonalization?.attributes?.some(({ name: name, value: value })=>name === isEstablishedUserTraitName && value === 'true'));
    return {
        isEstablishedUser: isEstablishedUser,
        loading: loading,
        error: error
    };
};
module.exports["useIsEstablishedUser"] = $e4b48658f7bfd739$export$fbded7f0a0c86e5e;

});

parcelRegister("2FNNv", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");

// Production trait: https://data-portal.internal.atlassian.com/targeting/traits/f0c5d949-91be-46e0-b440-7d7a953c9159
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME = 'confluence_is_established_user';
// Staging trait: https://data-portal-stg.internal.atlassian.com/targeting/traits/4015e85e-221b-4d95-a945-c68548e21a8b
// NOTE: DO NOT USE Staging trait named as `confluence_is_established_user` - this is a legacy trait created with wrong evaluation type and won't work for staging
const $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING = 'confluence_is_established_user_stg';
const $f30477d177bb95bd$export$a284916a4d5ed017 = ()=>{
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    if (environment !== 'PRODUCTION') return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME_STAGING;
    return $f30477d177bb95bd$var$IS_ESTABLISHED_USER_TRAIT_NAME;
};
module.exports["useIsEstablishedUserTraitName"] = $f30477d177bb95bd$export$a284916a4d5ed017;

});

parcelRegister("30D0J", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $0f856dd8e4045e89$export$241fc4ad38d78de1 = ({ skip: skip, onError: onError, variables: variables })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/user/${userId}`,
        method: 'GET',
        parseResult: (response)=>({
                experimentalUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(response.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables
    });
};
module.exports["useExperimentalUserPersonalizationQuery"] = $0f856dd8e4045e89$export$241fc4ad38d78de1;

});

parcelRegister("CIjCq", function(module, exports) {
/**
 * The TAP delivery API returns mixed types (boolean, number, string), but the
 * previous experimental GraphQL schema defined all values as String!, causing
 * automatic coercion. When bypassing GraphQL via useExperimentalQuery, we need
 * to manually coerce to maintain the same behavior consumer code expects.
 */ function $3c8babd51a2343c1$export$1660902c4f08468b(attributes) {
    if (!attributes) return [];
    return attributes.map((attr)=>({
            ...attr,
            value: String(attr.value)
        }));
}
module.exports["stringifyPersonalizationAttributes"] = $3c8babd51a2343c1$export$1660902c4f08468b;

});

parcelRegister("evORK", function(module, exports) {

var $dlSEv = parcelRequire("dlSEv");


var $9wGTI = parcelRequire("9wGTI");


var $kAcNG = parcelRequire("kAcNG");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $eeeb74b654b378be$export$c71507e40f69e111 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: siteUserPersonalizationData, loading: siteUserPersonalizationLoading, error: siteUserPersonalizationError } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const siteUserPersonalizationAttributes = siteUserPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = siteUserPersonalizationAttributes?.find(({ name: name })=>name === $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const { attributes: sitePersonalizationAttributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const AIFCBetaEnrolledDateTime = sitePersonalizationAttributes?.find(({ name: name })=>name === 'confluence_aifc_enabled_datetime')?.value;
    const isExistingUserBeforeAIFCBetaEnrolled = !!confluenceFirstActive && !!AIFCBetaEnrolledDateTime && (0, $dlSEv.default)(new Date(confluenceFirstActive), new Date(AIFCBetaEnrolledDateTime));
    if (sitePersonalizationError || sitePersonalizationLoading || siteUserPersonalizationError || siteUserPersonalizationLoading || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')) return {
        isAIFCOnbardingEligible: false,
        error: sitePersonalizationError || siteUserPersonalizationError,
        loading: sitePersonalizationLoading || siteUserPersonalizationLoading
    };
    return {
        isAIFCOnbardingEligible: isExistingUserBeforeAIFCBetaEnrolled,
        loading: false
    };
};
module.exports["useIsAIFCOnbardingEligible"] = $eeeb74b654b378be$export$c71507e40f69e111;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("kAcNG", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");


var $hcDKy = parcelRequire("hcDKy");

let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $hcDKy.useExperimentalSitePersonalizationQuery)({
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions,
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $aMcHK.isStatusCodeError)(graphQLError, '401') || (0, $1uFM6.isUnauthorizedError)(graphQLError));
        }
    });
    const attributes = data?.experimentalSitePersonalization?.attributes || [];
    return {
        loading: loading,
        error: error,
        attributes: attributes
    };
};
module.exports["useSitePersonalizationQuery"] = $a3e54b7319a42934$export$3cfde1d6c626a865;

});

parcelRegister("hcDKy", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $c7a26f042941282d$export$f9ec68434a742b9f = ({ skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
        method: 'GET',
        parseResult: (json)=>({
                experimentalSitePersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalSitePersonalizationQuery"] = $c7a26f042941282d$export$f9ec68434a742b9f;

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("cgSxj", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $ep3mz = parcelRequire("ep3mz");


var $iLgzu = parcelRequire("iLgzu");

const $3ddccd966453cb80$export$6dd95cedb3ff0cda = ()=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: defaultSpaceKeyData } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const { data: enabledContentTypesData } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query useIsLivePagesAvailableInSpaceSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`, {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    });
    return enabledContentTypesData ? enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes?.isLivePagesEnabled : false;
};
module.exports["useIsLivePagesAvailableInSpace"] = $3ddccd966453cb80$export$6dd95cedb3ff0cda;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("irr7I", function(module, exports) {

var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $gz8ZY = parcelRequire("gz8ZY");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_ENROLLED_TRAIT = 'segment_confluence_nav_4_changeboarding_cloned_siteuser';
const $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_COMPLETED_TRAIT = 'completed_cc-nav-4-changeboarding-prod';
const $e18371ec7eace185$var$isExpectedError = (error)=>{
    if ((0, $1uFM6.isUnauthorizedError)(error)) // 401s are expected when users don't have permissions
    return true;
    return false;
};
const $e18371ec7eace185$export$67ed1464307296e4 = ()=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { data: data, loading: loading, error: error } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !isNav4Enabled
    });
    if (error && $e18371ec7eace185$var$isExpectedError(error)) // Suppress error from Splunk
    (0, $7Sm4c.markErrorAsHandled)(error);
    if (!isNav4Enabled) return {
        isUserEnrolledInNav4Changeboarding: false,
        isUserCompletedNav4Changeboarding: false
    };
    const attributes = data?.experimentalSiteUserPersonalization?.attributes;
    const isUserEnrolledInNav4Changeboarding = Boolean(attributes?.some(({ name: name, value: value })=>name === $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_ENROLLED_TRAIT && value === 'true'));
    const isUserCompletedNav4Changeboarding = Boolean(attributes?.some(({ name: name, value: value })=>name === $e18371ec7eace185$var$NAV_4_CHANGEBOARDING_COMPLETED_TRAIT && !!value));
    return {
        isUserEnrolledInNav4Changeboarding: isUserEnrolledInNav4Changeboarding,
        isUserCompletedNav4Changeboarding: isUserCompletedNav4Changeboarding,
        loading: loading,
        error: error
    };
};
module.exports["useIsNav4Changeboarding"] = $e18371ec7eace185$export$67ed1464307296e4;

});

parcelRegister("3Yga2", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $6mKj3 = parcelRequire("6mKj3");

const $6522d8231f11b4f4$var$MAX_TIMES_SHOWN = 3;
const $6522d8231f11b4f4$export$2dd930e418397758 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return true;
    const currentValue = Number((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER));
    return currentValue < $6522d8231f11b4f4$var$MAX_TIMES_SHOWN;
};
const $6522d8231f11b4f4$export$ac038305f1d136b9 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return;
    const currentValue = Number((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER));
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, currentValue + 1);
};
const $6522d8231f11b4f4$export$78c6def31d4333a6 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return;
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, $6522d8231f11b4f4$var$MAX_TIMES_SHOWN);
};
const $6522d8231f11b4f4$export$fb6c8b2f3b8bb597 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return;
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, 0);
};
module.exports["checkShouldShowLozenge"] = $6522d8231f11b4f4$export$2dd930e418397758;
module.exports["iterateLozengeShownTracker"] = $6522d8231f11b4f4$export$ac038305f1d136b9;
module.exports["setLozengeShownTrackerMax"] = $6522d8231f11b4f4$export$78c6def31d4333a6;

});

parcelRegister("eB1TF", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $bf0e479659c73d50$var$initialState = {
    isOpen: false,
    openFrom: ''
};
const $bf0e479659c73d50$var$actions = {
    setIsOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        },
    setOpenFrom: (openFrom)=>({ setState: setState })=>{
            setState({
                openFrom: openFrom
            });
        }
};
const $bf0e479659c73d50$var$Store = (0, $1P1Tu.createStore)({
    initialState: $bf0e479659c73d50$var$initialState,
    actions: $bf0e479659c73d50$var$actions,
    name: 'UniversalCreateStore'
});
const $bf0e479659c73d50$export$c7381b2490bb4d36 = (0, $9zUhf.createStateHook)($bf0e479659c73d50$var$Store);
const $bf0e479659c73d50$export$6c5b9a107b000099 = (0, $9zUhf.createActionsHook)($bf0e479659c73d50$var$Store);
module.exports["useUniversalCreateState"] = $bf0e479659c73d50$export$c7381b2490bb4d36;
module.exports["useUniversalCreateActions"] = $bf0e479659c73d50$export$6c5b9a107b000099;

});

parcelRegister("6e99h", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $de2j9 = parcelRequire("de2j9");


var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");


var $56QzY = parcelRequire("56QzY");


var $ep3mz = parcelRequire("ep3mz");


var $1KBSi = parcelRequire("1KBSi");


var $yuLaV = parcelRequire("yuLaV");


var $9wGTI = parcelRequire("9wGTI");


var $kDja4 = parcelRequire("kDja4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7EIq6 = parcelRequire("7EIq6");


var $fSDMD = parcelRequire("fSDMD");


var $jrwID = parcelRequire("jrwID");


var $dAC7y = parcelRequire("dAC7y");


var $ejGOi = parcelRequire("ejGOi");


var $3LivB = parcelRequire("3LivB");


var $1OVup = parcelRequire("1OVup");


var $fw6FY = parcelRequire("fw6FY");


var $4e5hr = parcelRequire("4e5hr");


var $8hdRZ = parcelRequire("8hdRZ");


var $a26i4 = parcelRequire("a26i4");

const $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $279d18c421fdc96b$var$messages = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    moreFromAtlassian: {
        id: "create-blank-fabric-page.universal-create.suggestions",
        defaultMessage: "Suggestions"
    }
});
function $279d18c421fdc96b$export$aad046bd9909db8f(flags, closeMenu, openFrom) {
    const $ = (0, $frIzR.c)(76);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isLivePage || $[2] !== isOnEditRoute || $[3] !== openFrom || $[4] !== routeDataRef) {
        t0 = (actionSubjectId, attributes)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: actionSubjectId,
                    source: $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        isOnEditRoute: isOnEditRoute,
                        currentRouteName: routeDataRef?.current?.routeName,
                        currentRouteIsLive: isLivePage,
                        openFrom: openFrom,
                        ...attributes
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isLivePage;
        $[2] = isOnEditRoute;
        $[3] = openFrom;
        $[4] = routeDataRef;
        $[5] = t0;
    } else t0 = $[5];
    const handleAnalyticsAndResetStickySearch = t0;
    let t1;
    if ($[6] !== closeMenu || $[7] !== handleAnalyticsAndResetStickySearch) {
        t1 = (actionSubjectId_0, attributes_0)=>{
            handleAnalyticsAndResetStickySearch(actionSubjectId_0, attributes_0);
            closeMenu?.();
        };
        $[6] = closeMenu;
        $[7] = handleAnalyticsAndResetStickySearch;
        $[8] = t1;
    } else t1 = $[8];
    const onClick = t1;
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const { canCreateSpace: canCreateSpace } = (0, $1KBSi.useCanCreateSpace)();
    const isLoomEntryPointEnabled = (0, $fSDMD.useIsCreateMenuLoomRecorderEntryPointEnabled)();
    let t2;
    if ($[9] !== contentId || $[10] !== onClick || $[11] !== spaceKey) {
        t2 = {
            source: "globalCreateDropdown-liveDoc",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[9] = contentId;
        $[10] = onClick;
        $[11] = spaceKey;
        $[12] = t2;
    } else t2 = $[12];
    const liveDoc = (0, $jrwID.useLiveDocItem)(t2);
    let t3;
    if ($[13] !== contentId || $[14] !== onClick || $[15] !== spaceKey) {
        t3 = {
            source: "globalCreateDropdown-page",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[13] = contentId;
        $[14] = onClick;
        $[15] = spaceKey;
        $[16] = t3;
    } else t3 = $[16];
    const page = (0, $dAC7y.usePageItem)(t3);
    let t4;
    if ($[17] !== contentId || $[18] !== onClick || $[19] !== spaceKey) {
        t4 = {
            source: "globalCreateDropdown-whiteboard",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[17] = contentId;
        $[18] = onClick;
        $[19] = spaceKey;
        $[20] = t4;
    } else t4 = $[20];
    const whiteboard = (0, $ejGOi.useWhiteboardItem)(t4);
    let t5;
    if ($[21] !== contentId || $[22] !== onClick || $[23] !== spaceKey) {
        t5 = {
            source: "globalCreateDropdown-database",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[21] = contentId;
        $[22] = onClick;
        $[23] = spaceKey;
        $[24] = t5;
    } else t5 = $[24];
    const database = (0, $3LivB.useDatabaseItem)(t5);
    let t6;
    if ($[25] !== contentId || $[26] !== onClick || $[27] !== spaceKey) {
        t6 = {
            source: "globalCreateDropdown-blog",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[25] = contentId;
        $[26] = onClick;
        $[27] = spaceKey;
        $[28] = t6;
    } else t6 = $[28];
    const blog = (0, $1OVup.useBlogItem)(t6);
    let t7;
    if ($[29] !== contentId || $[30] !== onClick || $[31] !== spaceKey) {
        t7 = {
            source: "globalCreateDropdown-smartLinkEmbed",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[29] = contentId;
        $[30] = onClick;
        $[31] = spaceKey;
        $[32] = t7;
    } else t7 = $[32];
    const embed = (0, $fw6FY.useEmbedItem)(t7);
    let t8;
    if ($[33] !== contentId || $[34] !== flags || $[35] !== onClick || $[36] !== spaceKey) {
        t8 = {
            source: "globalCreateDropdown-smartLinkEmbed",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick,
            flags: flags
        };
        $[33] = contentId;
        $[34] = flags;
        $[35] = onClick;
        $[36] = spaceKey;
        $[37] = t8;
    } else t8 = $[37];
    const loom = (0, $8hdRZ.useLoomItem)(t8);
    let t9;
    if ($[38] !== contentId || $[39] !== onClick || $[40] !== spaceKey) {
        t9 = {
            source: $279d18c421fdc96b$var$ANALYTICS_EVENT_SOURCE,
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[38] = contentId;
        $[39] = onClick;
        $[40] = spaceKey;
        $[41] = t9;
    } else t9 = $[41];
    const space = (0, $4e5hr.useSpaceItem)(t9);
    let t10;
    if ($[42] !== onClick || $[43] !== openFrom || $[44] !== spaceKey) {
        t10 = {
            source: "globalCreateDropdown-smartCreate",
            spaceKey: spaceKey,
            onClick: onClick,
            openFrom: openFrom
        };
        $[42] = onClick;
        $[43] = openFrom;
        $[44] = spaceKey;
        $[45] = t10;
    } else t10 = $[45];
    const smartCreate = (0, $a26i4.useAISmartCreateItem)(t10);
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    let t11;
    if ($[46] !== isWhiteboardFeatureEnabled) {
        t11 = isWhiteboardFeatureEnabled("whiteboardOptOut");
        $[46] = isWhiteboardFeatureEnabled;
        $[47] = t11;
    } else t11 = $[47];
    const isOptedOutedOfWhiteboards = t11;
    let t12;
    if ($[48] !== isWhiteboardFeatureEnabled) {
        t12 = isWhiteboardFeatureEnabled("whiteboardsEnabled");
        $[48] = isWhiteboardFeatureEnabled;
        $[49] = t12;
    } else t12 = $[49];
    const isWhiteboardsEnabled = t12;
    const whiteboardOptIn = !isOptedOutedOfWhiteboards && isWhiteboardsEnabled;
    let t13;
    if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("database") && !(0, $9wGTI.fg)("confluence_frontend_databases_opt-out");
        $[50] = t13;
    } else t13 = $[50];
    const databaseOptIn = t13;
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    let t14;
    if ($[51] !== blog || $[52] !== canCreateSpace || $[53] !== database || $[54] !== embed || $[55] !== isAnonymousUser || $[56] !== isCreateBlogEnabled || $[57] !== isCreateDatabaseEnabled || $[58] !== isCreateLiveDocEnabled || $[59] !== isCreateSmartLinkEnabled || $[60] !== isCreateWhiteboardEnabled || $[61] !== isRovoLLMEnabled || $[62] !== liveDoc || $[63] !== page || $[64] !== smartCreate || $[65] !== space || $[66] !== whiteboard || $[67] !== whiteboardOptIn) {
        const getNativeItems = ()=>{
            const isAifcEnabled = isRovoLLMEnabled && !isAnonymousUser && (0, $9wGTI.fg)("aifc_create_enabled");
            return {
                items: [
                    ...isAifcEnabled ? [
                        smartCreate
                    ] : [],
                    ...isCreateLiveDocEnabled ? [
                        liveDoc
                    ] : [],
                    page,
                    ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                        whiteboard
                    ] : [],
                    ...isCreateDatabaseEnabled && databaseOptIn ? [
                        database
                    ] : [],
                    ...isCreateBlogEnabled ? [
                        blog
                    ] : [],
                    ...isCreateSmartLinkEnabled ? [
                        embed
                    ] : [],
                    ...canCreateSpace ? [
                        space
                    ] : []
                ]
            };
        };
        t14 = getNativeItems();
        $[51] = blog;
        $[52] = canCreateSpace;
        $[53] = database;
        $[54] = embed;
        $[55] = isAnonymousUser;
        $[56] = isCreateBlogEnabled;
        $[57] = isCreateDatabaseEnabled;
        $[58] = isCreateLiveDocEnabled;
        $[59] = isCreateSmartLinkEnabled;
        $[60] = isCreateWhiteboardEnabled;
        $[61] = isRovoLLMEnabled;
        $[62] = liveDoc;
        $[63] = page;
        $[64] = smartCreate;
        $[65] = space;
        $[66] = whiteboard;
        $[67] = whiteboardOptIn;
        $[68] = t14;
    } else t14 = $[68];
    const menuItems = [
        t14
    ];
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (isCreateSmartLinkEnabled && isLoomEntryPointEnabled) {
        let t15;
        if ($[69] !== formatMessage) {
            t15 = formatMessage($279d18c421fdc96b$var$messages.moreFromAtlassian);
            $[69] = formatMessage;
            $[70] = t15;
        } else t15 = $[70];
        let t16;
        if ($[71] !== loom) {
            t16 = [
                loom
            ];
            $[71] = loom;
            $[72] = t16;
        } else t16 = $[72];
        let t17;
        if ($[73] !== t15 || $[74] !== t16) {
            t17 = {
                heading: t15,
                items: t16
            };
            $[73] = t15;
            $[74] = t16;
            $[75] = t17;
        } else t17 = $[75];
        menuItems.push(t17);
    }
    return menuItems;
}
module.exports["useMenuItems"] = $279d18c421fdc96b$export$aad046bd9909db8f;

});

parcelRegister("1KBSi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $fEhQK = parcelRequire("fEhQK");

const $15029de520f1b9e8$export$cadd7e072478f5e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(6);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const t0 = !isLicensed;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            skip: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { data: canCreateData } = (0, $jMyy4.useQueryInterop)((0, $fEhQK.default), t1);
    let t2;
    if ($[2] !== canCreateData?.user?.confluence?.operations) {
        t2 = canCreateData?.user?.confluence?.operations.some($15029de520f1b9e8$var$_temp);
        $[2] = canCreateData?.user?.confluence?.operations;
        $[3] = t2;
    } else t2 = $[3];
    const canCreateSpace = Boolean(t2);
    let t3;
    if ($[4] !== canCreateSpace) {
        t3 = {
            canCreateSpace: canCreateSpace
        };
        $[4] = canCreateSpace;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: canCreateData } = (0, $jMyy4.useQueryInterop)(// Due to circular dependency issues we are using the PreloadCreateSpaceQuery from create-space-preload package
    (0, $fEhQK.default), {
        skip: !isLicensed
    });
    const canCreateSpace = Boolean(canCreateData?.user?.confluence?.operations.some((obj)=>obj?.operation === 'create_space'));
    return {
        canCreateSpace: canCreateSpace
    };
};
function $15029de520f1b9e8$var$_temp(obj) {
    return obj?.operation === "create_space";
}
module.exports["useCanCreateSpace"] = $15029de520f1b9e8$export$cadd7e072478f5e;

});

parcelRegister("fEhQK", function(module, exports) {
/**
 * @generated SignedSource<<e3dd06d27d8a1f0e6d8bc9c98ac1162e>>
 * @relayHash a615654a08ce3274fc54e07efd9211ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf
const $ba87c6a44dc20089$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a615654a08ce3274fc54e07efd9211ea",
            "id": "e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf",
            "metadata": {},
            "name": "preloadCreateSpaceQuery",
            "operationKind": "query",
            "text": "query preloadCreateSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation}}}}"
        }
    };
}();
$ba87c6a44dc20089$var$node.hash = "9a716c385cdfcba90204a7cf16292b9a";
var $ba87c6a44dc20089$export$2e2bcd8739ae039 = $ba87c6a44dc20089$var$node;
module.exports["default"] = $ba87c6a44dc20089$export$2e2bcd8739ae039;

});

parcelRegister("yuLaV", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard') {
        // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKey = contentType === 'database' ? 'confluence-databases' : 'confluence-whiteboards';
            return (0, $5spQU.isFeatureEnabled)('confluence', featureKey);
        }
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return (0, $9wGTI.fg)('aifc_create_enabled');
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("jrwID", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $e0ycV = parcelRequire("e0ycV");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");


var $8Qafc = parcelRequire("8Qafc");


var $dilhZ = parcelRequire("dilhZ");


var $3J7nf = parcelRequire("3J7nf");


var $dPJCf = parcelRequire("dPJCf");


var $b3j2Y = parcelRequire("b3j2Y");


var $9wGTI = parcelRequire("9wGTI");


var $3Yga2 = parcelRequire("3Yga2");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");


var $dkIiA = parcelRequire("dkIiA");


var $jo6R7 = parcelRequire("jo6R7");

const $27cf2e1d8d21e923$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.liveDoc.title",
        defaultMessage: "Live Doc"
    },
    newLozenge: {
        id: "create-blank-fabric-page.universal-create.liveDoc.new.lozenge",
        defaultMessage: "New"
    }
});
const $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM = 'create-live-doc-popover-item';
function $27cf2e1d8d21e923$export$5af7ed73ba9cf3af(t0) {
    const $ = (0, $frIzR.c)(28);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "page",
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createLiveDocPopoverItem");
            hybridLinkClick(e);
            (0, $3Yga2.setLozengeShownTrackerMax)();
        };
        $[5] = hybridLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $3Yga2.checkShouldShowLozenge)();
        $[8] = t4;
    } else t4 = $[8];
    const shouldShowLozenge = t4;
    let t5;
    if ($[9] !== formatMessage) {
        t5 = (0, $9wGTI.fg)("confluence_remove_live_page_lozenge_hello") || !shouldShowLozenge ? formatMessage($27cf2e1d8d21e923$var$messages.title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jo6R7.ItemTitleWithLozenge), {
            lozenge: formatMessage($27cf2e1d8d21e923$var$messages.newLozenge)
        }, formatMessage($27cf2e1d8d21e923$var$messages.title));
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    const titleItem = t5;
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:livedoc");
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== enforceStorageLimit || $[13] !== handleClick) {
        t7 = enforceStorageLimit(handleClick);
        $[12] = enforceStorageLimit;
        $[13] = handleClick;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== createHref || $[16] !== shouldBlockCreate) {
        t8 = !shouldBlockCreate && {
            href: createHref
        };
        $[15] = createHref;
        $[16] = shouldBlockCreate;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== createHref || $[19] !== handleClick || $[20] !== source) {
        t9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($27cf2e1d8d21e923$var$LiveDocSpotlightWrapper, {
                ...props,
                source: source,
                createHref: createHref,
                handleClick: handleClick
            });
        $[18] = createHref;
        $[19] = handleClick;
        $[20] = source;
        $[21] = t9;
    } else t9 = $[21];
    const t10 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t11;
    if ($[22] !== t10 || $[23] !== t7 || $[24] !== t8 || $[25] !== t9 || $[26] !== titleItem) {
        t11 = {
            ati: t6,
            children: titleItem,
            onClick: t7,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            ...t8,
            Wrapper: t9,
            testId: t10
        };
        $[22] = t10;
        $[23] = t7;
        $[24] = t8;
        $[25] = t9;
        $[26] = titleItem;
        $[27] = t11;
    } else t11 = $[27];
    return t11;
}
const $27cf2e1d8d21e923$var$LiveDocSpotlightWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { children: children, source: source, createHref: createHref, handleClick: handleClick } = t0;
    const hasFiredOnStartEventRef = (0, $42omo.useRef)(false);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { introSpotlight: introSpotlight, error: error } = (0, $3J7nf.useLiveDocChangeboarding)();
    const { isVisible: shouldShowIntroSpotlight, complete: completeIntroSpotlight } = introSpotlight;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== createAnalyticsEvent || $[2] !== source) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "shown",
                    actionSubject: "spotlight",
                    actionSubjectId: "liveDocIntro",
                    source: source
                }
            }).fire();
        };
        $[1] = createAnalyticsEvent;
        $[2] = source;
        $[3] = t2;
    } else t2 = $[3];
    const onSpotlightStart = t2;
    let t3;
    let t4;
    if ($[4] !== onSpotlightStart || $[5] !== shouldShowIntroSpotlight) {
        t3 = ()=>{
            if (shouldShowIntroSpotlight && !hasFiredOnStartEventRef.current) {
                onSpotlightStart();
                hasFiredOnStartEventRef.current = true;
            }
        };
        t4 = [
            shouldShowIntroSpotlight,
            onSpotlightStart
        ];
        $[4] = onSpotlightStart;
        $[5] = shouldShowIntroSpotlight;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[8] !== completeIntroSpotlight || $[9] !== createHref || $[10] !== enforceStorageLimit || $[11] !== error || $[12] !== handleClick || $[13] !== push || $[14] !== source) {
        t5 = (element)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dilhZ.CreateLiveDocPopoverItemSpotlight), {
                handleDismiss: ()=>{
                    completeIntroSpotlight();
                },
                handleProceed: enforceStorageLimit((e)=>{
                    completeIntroSpotlight();
                    handleClick(e);
                    push(createHref);
                }),
                targetName: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM,
                source: source,
                fireAnalyticsEventOnMessageDisposition: false
            }, element, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }));
        $[8] = completeIntroSpotlight;
        $[9] = createHref;
        $[10] = enforceStorageLimit;
        $[11] = error;
        $[12] = handleClick;
        $[13] = push;
        $[14] = source;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== children) {
        t6 = children();
        $[16] = children;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== shouldShowIntroSpotlight || $[19] !== t5 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Qafc.CreateButtonSpotlightPulseWrapper), {
            condition: shouldShowIntroSpotlight,
            wrapper: t5
        }, t6);
        $[18] = shouldShowIntroSpotlight;
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    return t7;
});
module.exports["useLiveDocItem"] = $27cf2e1d8d21e923$export$5af7ed73ba9cf3af;

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<634d8ca034d2498a989d5a4ffee872da>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $6mKj3 = parcelRequire("6mKj3");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    journeyId: 'journeyId',
    templateKey: 'templateKey',
    /* Created By Flow Analytic contributes to Core Actions/FO and should sometimes be disabled 
  (ex: user going through onboarding may be firing this event during onboarding screens and should not contribute to KR metric)*/ disableCreatedByFlowAnalytic: 'dcbfa'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    if ('disableCreatedByFlowAnalytic' in options && options.disableCreatedByFlowAnalytic) queryParams[$e7afa99020494478$var$queryParamKeys.disableCreatedByFlowAnalytic] = options.disableCreatedByFlowAnalytic;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) {
        if (contentType === "folder" && !(0, $6mKj3.UNSAFE_expValNoExposure)("cfind-4930-get-started-doc-notification", "isEnabled", false)) return;
        return contentType;
    }
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    const disableCreatedByFlowAnalytic = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.disableCreatedByFlowAnalytic) === 'true';
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        journeyId: journeyId,
        templateKey: templateKey,
        disableCreatedByFlowAnalytic: disableCreatedByFlowAnalytic
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("dkIiA", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("jo6R7", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $5nBzc = parcelRequire("5nBzc");


var $ibDKJ = parcelRequire("ibDKJ");

const $925aeaac5c2ec2fe$var$titleSpacingStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.075'
});
const $925aeaac5c2ec2fe$export$32629a9f34b6d093 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, lozenge: lozenge, useLabsLozenge: useLabsLozenge } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $925aeaac5c2ec2fe$var$titleSpacingStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== lozenge || $[3] !== useLabsLozenge) {
        t2 = useLabsLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ibDKJ.AILabsLozenge), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "new"
        }, lozenge);
        $[2] = lozenge;
        $[3] = useLabsLozenge;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            justifyContent: "space-between"
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ItemTitleWithLozenge"] = $925aeaac5c2ec2fe$export$32629a9f34b6d093;

});

parcelRegister("ibDKJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $cOrQJ = parcelRequire("cOrQJ");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $36Swo = parcelRequire("36Swo");

const $e5b02ec9368d4295$var$i18n = (0, $cgtv4.defineMessages)({
    tooltip: {
        id: "ai-common.ai-labs-lozenge.tooltip",
        defaultMessage: "Beta: This feature is still in development."
    }
});
const $e5b02ec9368d4295$var$lozengeStyles = {
    lozenge: "_2rko12b0 _18zr1b66 _1e0c1txw _4cvr1h6o _1bah1h6o",
    tooltip: "_2rko12b0 _11c8wadc _vchhusvi _p12f7l9q _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
};
const $e5b02ec9368d4295$var$gradientWaveKeyframes = null;
const $e5b02ec9368d4295$var$lozengeAnimatedBorder = null; // Using a custom tooltip is a workaround to avoid odd spacing due to default styles,
// primarily for the English locale
const $e5b02ec9368d4295$var$CustomTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            $e5b02ec9368d4295$var$lozengeStyles.tooltip
        ]),
        children: children
    });
});
const $e5b02ec9368d4295$export$48aba4499a97f6bf = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)(); // We don't want to i18n the term 'AI Labs' because it is the branding name
    // and should be the same across all languages
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        component: $e5b02ec9368d4295$var$CustomTooltip,
        content: formatMessage($e5b02ec9368d4295$var$i18n.tooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": "ai-labs-lozenge",
            className: (0, $gMc0m.default)([
                $e5b02ec9368d4295$var$lozengeStyles.lozenge,
                "_2rko12b0 _18zr1b66 _kqswh2mm _bfhksm61 _1e0c1txw _4cvr1h6o _1bah1h6o _1pbyidpf _1tesidpf _rfx312b0 _1414t94y _p7f0t94y _7gpxt94y _syayt94y _1s6kyrfl _16qq1ajn _1kt9b3bt _1cs8stnw _1ankm4tz _12a1epuu _x5brkvto _13sb1p67 _dsq4glyw _1g0v1mrw"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                grow: "hug",
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $36Swo.LabsIcon), {
                        darkMode: colorMode === 'dark'
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            weight: "semibold",
                            color: "color.text",
                            children: "LABS"
                        })
                    })
                ]
            })
        })
    });
};
module.exports["AILabsLozenge"] = $e5b02ec9368d4295$export$48aba4499a97f6bf;

});

parcelRegister("cOrQJ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8z9j5 = parcelRequire("8z9j5");


var $60yhz = parcelRequire("60yhz");

/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $3ebd34920f1cc52c$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $42omo.useState)((0, $8z9j5.default)());
    (0, $42omo.useEffect)(()=>{
        const observer = new (0, $60yhz.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $3ebd34920f1cc52c$export$2e2bcd8739ae039 = $3ebd34920f1cc52c$var$useThemeObserver;
module.exports["default"] = $3ebd34920f1cc52c$export$2e2bcd8739ae039;

});

parcelRegister("36Swo", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $ffeb61eca9109eeb$export$36be37b392de5213 = ({ darkMode: darkMode = false })=>{
    return darkMode ? /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon-dark",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_1466_13761)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1466_13761",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "8.25276",
                        height: "7.89",
                        fill: "white",
                        transform: "translate(0.9375 0.0625)"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_1352_45568)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
                    fill: "#1E1F21"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1352_45568",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "8.25276",
                        height: "7.89",
                        fill: "white",
                        transform: "translate(0.9375 0.0625)"
                    })
                })
            })
        ]
    });
};
module.exports["LabsIcon"] = $ffeb61eca9109eeb$export$36be37b392de5213;

});

parcelRegister("dAC7y", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $8jHAi = parcelRequire("8jHAi");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");

const $f6498381976d168b$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.title",
        defaultMessage: "Page"
    }
});
function $f6498381976d168b$export$e324b86258d66a8f(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-page-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "page",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createPagePopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:page");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($f6498381976d168b$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}
module.exports["usePageItem"] = $f6498381976d168b$export$e324b86258d66a8f;

});

parcelRegister("ejGOi", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ZDq1z = parcelRequire("ZDq1z");


var $inPa6 = parcelRequire("inPa6");


var $gj7hi = parcelRequire("gj7hi");


var $6yCpa = parcelRequire("6yCpa");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");


var $lqy4C = parcelRequire("lqy4C");


var $eVXGa = parcelRequire("eVXGa");


var $8aF6s = parcelRequire("8aF6s");


var $lv5Bc = parcelRequire("lv5Bc");

var $gUusY = parcelRequire("gUusY");


var $8fj5s = parcelRequire("8fj5s");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $eB1TF = parcelRequire("eB1TF");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");


var $5nX81 = parcelRequire("5nX81");


var $fCfQ7 = parcelRequire("fCfQ7");


var $98wxI = parcelRequire("98wxI");


var $dcUvx = parcelRequire("dcUvx");

const $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT = 'cc-whiteboard-nudge-global-create-experiment';
const $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM = 'globalCreateCohort';
const $10e7e2c648ba4dd0$export$118062d2c7c760ca = {
    experimentName: $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT,
    cohort: $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM
};
const $10e7e2c648ba4dd0$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.whiteboard.title",
        defaultMessage: "Whiteboard"
    },
    toolTipTextAnonymous: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-anonymous",
        defaultMessage: "Log in to create a whiteboard"
    },
    toolTipTextUnlicensed: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-unlicensed",
        defaultMessage: "Sign up to Confluence to create a whiteboard"
    }
});
const $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES = {
    contentType: 'whiteboard',
    paywallFlow: 'upfront'
};
const $10e7e2c648ba4dd0$var$f1GameStyles = {
    itemWrapper: "_4cvr1h6o _1bah1yb4 _1e0c1txw _kqswh2mm",
    childrenWrapper: "_16jlkb7n",
    rightIcon: "_4t3idlk8 _kqswstnw _1xi2pxbi _lcxvglyw"
};
const $10e7e2c648ba4dd0$var$F1GameWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { children: children } = t0;
    const [showRacecarIcon, setShowRacecarIcon] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (_)=>{
            (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && setShowRacecarIcon(true);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleOnMouseEnter = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (__0)=>{
            (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && setShowRacecarIcon(false);
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleOnMouseLeave = t2;
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.itemWrapper
        ]);
        t4 = (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.childrenWrapper
        ]);
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    let t5;
    if ($[4] !== children) {
        t5 = children();
        $[4] = children;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t4
        }, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== showRacecarIcon) {
        t7 = showRacecarIcon && (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dcUvx))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dcUvx))),
            alt: "",
            testId: "confluence-whiteboards-car-icon",
            className: (0, $gMc0m.default)([
                $10e7e2c648ba4dd0$var$f1GameStyles.rightIcon
            ])
        });
        $[8] = showRacecarIcon;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t6 || $[11] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: handleOnMouseEnter,
            onFocus: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            onBlur: handleOnMouseLeave,
            className: t3
        }, t6, t7);
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
};
function $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5(t0) {
    const $ = (0, $frIzR.c)(59);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== isOpen) {
        t1 = (0, $9wGTI.fg)("load-whiteboards-paywall-query-when-menu-is-open") && !isOpen;
        $[0] = isOpen;
        $[1] = t1;
    } else t1 = $[1];
    const skipPaywallQuery = t1;
    const { deactivationIdentifier: deactivationIdentifier, error: creationPaywallError, paywallStatus: paywallStatus, showPaywallBeforeCreate: showPaywallBeforeCreate } = (0, $5nX81.useWhiteboardCreationPaywall)(skipPaywallQuery);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "create-whiteboard-popover-item"
        };
        $[2] = t2;
    } else t2 = $[2];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t2);
    let t3;
    if ($[3] !== deactivationIdentifier || $[4] !== parentId || $[5] !== paywallStatus || $[6] !== source || $[7] !== spaceKey) {
        t3 = (t4, t5)=>{
            const creationOverrides = t4 === undefined ? {} : t4;
            const sourceSuffix = t5 === undefined ? "" : t5;
            return (0, $bZSO8.buildCreationLink)({
                contentType: "whiteboard",
                parentPageId: parentId,
                withFallback: true,
                source: source + sourceSuffix,
                spaceKey: spaceKey,
                deactivationIdentifier: deactivationIdentifier,
                paywallStatus: paywallStatus,
                ...creationOverrides
            });
        };
        $[3] = deactivationIdentifier;
        $[4] = parentId;
        $[5] = paywallStatus;
        $[6] = source;
        $[7] = spaceKey;
        $[8] = t3;
    } else t3 = $[8];
    const buildWhiteboardCreationLink = t3;
    let t4;
    if ($[9] !== buildWhiteboardCreationLink) {
        t4 = buildWhiteboardCreationLink();
        $[9] = buildWhiteboardCreationLink;
        $[10] = t4;
    } else t4 = $[10];
    const createHref = t4;
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t5;
    if ($[11] !== buildWhiteboardCreationLink || $[12] !== createAnalyticsEvent || $[13] !== creationPaywallError || $[14] !== experienceTracker || $[15] !== hybridLinkClick || $[16] !== onClick || $[17] !== paywallStatus || $[18] !== showModal || $[19] !== showPaywallBeforeCreate || $[20] !== source) {
        t5 = (e)=>{
            onClick("createWhiteboardPopoverItem");
            if ((0, $9wGTI.fg)("confluence_content_creation_paywall_fix_enabled")) {
                experienceTracker.start({
                    name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                    attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES,
                    collect: (0, $5nX81.collectStartCreateWhiteboardExperience)
                });
                if (creationPaywallError) experienceTracker.fail({
                    name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                    error: creationPaywallError
                });
            }
            if (showPaywallBeforeCreate) {
                e.stopPropagation();
                e.preventDefault();
                showModal((0, $fCfQ7.WhiteboardCreationPaywallDialog), {
                    buildWhiteboardCreationLink: buildWhiteboardCreationLink
                });
            } else {
                if (paywallStatus === (0, $98wxI.PaywallStatus).UNSET) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "createUnsetWhiteboardLink",
                        source: source,
                        attributes: {
                            reason: creationPaywallError ? "error" : "loading"
                        }
                    }
                }).fire();
                hybridLinkClick(e);
            }
        };
        $[11] = buildWhiteboardCreationLink;
        $[12] = createAnalyticsEvent;
        $[13] = creationPaywallError;
        $[14] = experienceTracker;
        $[15] = hybridLinkClick;
        $[16] = onClick;
        $[17] = paywallStatus;
        $[18] = showModal;
        $[19] = showPaywallBeforeCreate;
        $[20] = source;
        $[21] = t5;
    } else t5 = $[21];
    const handleClick = t5;
    const { getExperiment: getExperiment, skipCoordinationClientForExperiment: skipCoordinationClientForExperiment } = (0, $gUusY.useWhiteboardNudgeExperiments)($10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT, $10e7e2c648ba4dd0$var$GLOBAL_CREATE_EXPERIMENT_PARAM);
    const [isWhiteboardExperimentationSpotlightActive, stopWhiteboardExperimentationSpotlight] = (0, $8fj5s.useSkippableCoordination)("cc-whiteboards-nudge-exp-spotlight-v2", shouldBlockCreate || skipCoordinationClientForExperiment);
    const [isSpotlightOpen, setIsSpotlightOpen] = (0, $42omo.useState)(true);
    let t6;
    if ($[22] !== getExperiment || $[23] !== isWhiteboardExperimentationSpotlightActive) {
        t6 = isWhiteboardExperimentationSpotlightActive && getExperiment($10e7e2c648ba4dd0$export$118062d2c7c760ca.experimentName, $10e7e2c648ba4dd0$export$118062d2c7c760ca.cohort, true) === "variation";
        $[22] = getExperiment;
        $[23] = isWhiteboardExperimentationSpotlightActive;
        $[24] = t6;
    } else t6 = $[24];
    const isEligibleToSeeSpotlight = t6;
    let t7;
    if ($[25] !== stopWhiteboardExperimentationSpotlight) {
        t7 = ()=>{
            setIsSpotlightOpen(false);
            stopWhiteboardExperimentationSpotlight();
        };
        $[25] = stopWhiteboardExperimentationSpotlight;
        $[26] = t7;
    } else t7 = $[26];
    const handleSpotlightClose = t7;
    let t8;
    if ($[27] !== createHref || $[28] !== handleClick || $[29] !== handleSpotlightClose || $[30] !== source) {
        t8 = (t9)=>{
            const { children: children } = t9;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lv5Bc.CreateWhiteboardExperimentPopoverItemSpotlight), {
                createHref: createHref,
                spotlightDialogPlacement: "right middle",
                handleSpotlightClose: handleSpotlightClose,
                handleClosePopoverMenu: handleClick,
                source: source,
                shouldWatchTarget: true
            }, children());
        };
        $[27] = createHref;
        $[28] = handleClick;
        $[29] = handleSpotlightClose;
        $[30] = source;
        $[31] = t8;
    } else t8 = $[31];
    const WhiteboardSpotlightWrapper = t8;
    let t9;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:whiteboard");
        $[32] = t9;
    } else t9 = $[32];
    let t10;
    if ($[33] !== creationPaywallError) {
        t10 = !(0, $9wGTI.fg)("confluence_content_creation_paywall_fix_enabled") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            collect: (0, $5nX81.collectStartCreateWhiteboardExperience),
            attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES
        }), creationPaywallError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            error: creationPaywallError
        }));
        $[33] = creationPaywallError;
        $[34] = t10;
    } else t10 = $[34];
    let t11;
    if ($[35] !== formatMessage) {
        t11 = formatMessage($10e7e2c648ba4dd0$var$messages.title);
        $[35] = formatMessage;
        $[36] = t11;
    } else t11 = $[36];
    let t12;
    if ($[37] !== t10 || $[38] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, t10, t11);
        $[37] = t10;
        $[38] = t11;
        $[39] = t12;
    } else t12 = $[39];
    let t13;
    if ($[40] !== enforceStorageLimit || $[41] !== handleClick) {
        t13 = enforceStorageLimit(handleClick);
        $[40] = enforceStorageLimit;
        $[41] = handleClick;
        $[42] = t13;
    } else t13 = $[42];
    let t14;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && {
            Wrapper: $10e7e2c648ba4dd0$var$F1GameWrapper
        };
        $[43] = t14;
    } else t14 = $[43];
    let t15;
    if ($[44] !== createHref || $[45] !== isAllowedToCreateWhiteboard || $[46] !== shouldBlockCreate) {
        t15 = !shouldBlockCreate && isAllowedToCreateWhiteboard && {
            href: createHref
        };
        $[44] = createHref;
        $[45] = isAllowedToCreateWhiteboard;
        $[46] = shouldBlockCreate;
        $[47] = t15;
    } else t15 = $[47];
    let t16;
    if ($[48] !== WhiteboardSpotlightWrapper || $[49] !== isAllowedToCreateWhiteboard || $[50] !== isEligibleToSeeSpotlight || $[51] !== isSpotlightOpen) {
        t16 = isSpotlightOpen && isEligibleToSeeSpotlight && isAllowedToCreateWhiteboard && {
            Wrapper: WhiteboardSpotlightWrapper
        };
        $[48] = WhiteboardSpotlightWrapper;
        $[49] = isAllowedToCreateWhiteboard;
        $[50] = isEligibleToSeeSpotlight;
        $[51] = isSpotlightOpen;
        $[52] = t16;
    } else t16 = $[52];
    const t17 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t18;
    if ($[53] !== t12 || $[54] !== t13 || $[55] !== t15 || $[56] !== t16 || $[57] !== t17) {
        t18 = {
            ati: t9,
            children: t12,
            onClick: t13,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
            ...t14,
            ...t15,
            ...t16,
            testId: t17
        };
        $[53] = t12;
        $[54] = t13;
        $[55] = t15;
        $[56] = t16;
        $[57] = t17;
        $[58] = t18;
    } else t18 = $[58];
    return t18;
}
module.exports["useWhiteboardItem"] = $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5;

});

parcelRegister("gj7hi", function(module, exports) {
$parcel$export(module.exports, "default", () => $df095e8eefdd8265$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hWSc7 = parcelRequire("hWSc7");


var $cOrQJ = parcelRequire("cOrQJ");

const $df095e8eefdd8265$var$baseImageStyles = null; /**
                               * __Image__
                               *
                               * This component can be used interchangeably with the native `img` element. It includes additional functionality, such as theme support.
                               *
                               * - [Examples](https://atlassian.design/components/image/examples)
                               * - [Code](https://atlassian.design/components/image/code)
                               * - [Usage](https://atlassian.design/components/image/usage)
                               */ 
function $df095e8eefdd8265$export$2e2bcd8739ae039({ src: src, srcDark: srcDark, alt: alt, testId: testId, className: className, ...props }) {
    const imgRef = (0, $42omo.useRef)(null);
    const providedColorMode = (0, $hWSc7.UNSAFE_useColorModeForMigration)();
    const { colorMode: observedColorMode } = (0, $cOrQJ.default)();
    const colorMode = providedColorMode || observedColorMode;
    (0, $42omo.useEffect)(()=>{
        if (imgRef === null || imgRef.current === null) return;
        if (srcDark && colorMode === 'dark') imgRef.current.src = srcDark;
        else if (src) imgRef.current.src = src;
    }, [
        src,
        srcDark,
        colorMode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        "data-testid": testId,
        src: src,
        className: (0, $gMc0m.default)([
            "_p12f1osq _4t3i1wug",
            className
        ]),
        ref: imgRef,
        ...props
    });
}

});

parcelRegister("hWSc7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1aJUB = parcelRequire("1aJUB");

function $89c9339d073609a7$export$ce91654eb9fea460() {
    const value = (0, $42omo.useContext)((0, $1aJUB.ColorModeContext));
    return value;
}
module.exports["UNSAFE_useColorModeForMigration"] = $89c9339d073609a7$export$ce91654eb9fea460;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("8aF6s", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $42omo = parcelRequire("42omo");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $1P1Tu.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $9zUhf.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $42omo.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $9zUhf.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $42omo.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("dcUvx", function(module, exports) {
module.exports = new URL("Racecar.f378b1ee.svg", import.meta.url).toString();

});

parcelRegister("3LivB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6B0jU = parcelRequire("6B0jU");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");

const $c6e82055c002803e$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.database",
        defaultMessage: "Database"
    }
});
function $c6e82055c002803e$export$c03ba1b69410a0fd(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-database-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        const createContentOptions = {
            contentType: "database",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        };
        t2 = (0, $bZSO8.buildCreationLink)(createContentOptions);
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createDatabasePopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:database");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($c6e82055c002803e$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}
module.exports["useDatabaseItem"] = $c6e82055c002803e$export$c03ba1b69410a0fd;

});

parcelRegister("1OVup", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9RVmI = parcelRequire("9RVmI");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");

const $b66cd3653b467139$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.blog.title",
        defaultMessage: "Blog"
    }
});
function $b66cd3653b467139$export$1850e31ba3eb45b0(t0) {
    const $ = (0, $frIzR.c)(21);
    const { source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-blog-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== source || $[2] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "blog",
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = source;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[4] !== hybridPageLinkClick || $[5] !== onClick) {
        t3 = (e)=>{
            onClick("createBlogPopoverItem");
            hybridPageLinkClick(e);
        };
        $[4] = hybridPageLinkClick;
        $[5] = onClick;
        $[6] = t3;
    } else t3 = $[6];
    const handleClick = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:blogpost");
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage($b66cd3653b467139$var$messages.title);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== enforceStorageLimit || $[11] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[10] = enforceStorageLimit;
        $[11] = handleClick;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== createHref || $[14] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[13] = createHref;
        $[14] = shouldBlockCreate;
        $[15] = t7;
    } else t7 = $[15];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
            ...t7,
            testId: t8
        };
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
}
module.exports["useBlogItem"] = $b66cd3653b467139$export$1850e31ba3eb45b0;

});

parcelRegister("fw6FY", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $duwSm = parcelRequire("duwSm");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");

const $2e6ededdd99584ac$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.smart-link-embed.title",
        defaultMessage: "Smart Link"
    }
});
function $2e6ededdd99584ac$export$da2a30a64353a280(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-smart-link-embed-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        const createContentOptions = {
            contentType: "smartLinkEmbed",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        };
        t2 = (0, $bZSO8.buildCreationLink)(createContentOptions);
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createSmartLinkEmbedPopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:embed");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2e6ededdd99584ac$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($duwSm))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}
module.exports["useEmbedItem"] = $2e6ededdd99584ac$export$da2a30a64353a280;

});

parcelRegister("4e5hr", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $buthI = parcelRequire("buthI");


var $hbYDZ = parcelRequire("hbYDZ");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");


var $6yCpa = parcelRequire("6yCpa");


var $lBYCH = parcelRequire("lBYCH");


var $lqy4C = parcelRequire("lqy4C");


var $bAyaS = parcelRequire("bAyaS");


var $eSLr0 = parcelRequire("eSLr0");


var $4vyfK = parcelRequire("4vyfK");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jyA9t = parcelRequire("jyA9t");


var $bQm3c = parcelRequire("bQm3c");

const $293cf5b691bb25ab$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.space.title",
        defaultMessage: "Space"
    }
});
function $293cf5b691bb25ab$export$4adf07b2777336fa({ source: source, onClick: onClick }) {
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-space-button'
    });
    const { resetStickySearchRef: resetStickySearchRef, createContentPopoverButtonRef: createContentPopoverButtonRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const createSpaceButtonRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)((e)=>{
        resetStickySearchRef?.current?.();
        const location = 'topCreateNav';
        if (isRovoLLMEnabled && (0, $9wGTI.fg)('aifc_space_creation_enabled')) openModal('globalCreateSpaceButton', '');
        else openDrawer(createContentPopoverButtonRef || createSpaceButtonRef, location);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createSpaceButton',
                source: source,
                attributes: {
                    location: location
                }
            }
        }).fire();
        onClick('createSpacePopoverItem');
        e.stopPropagation();
    }, [
        createAnalyticsEvent,
        createContentPopoverButtonRef,
        openDrawer,
        onClick,
        openModal,
        resetStickySearchRef,
        source,
        isRovoLLMEnabled
    ]);
    const preloadCreateSpace = ()=>{
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.CREATE_SPACE_DIALOG)
        });
    };
    const PreloadSpaceWrap = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            onMouseDown: preloadCreateSpace
        }, children());
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:space'),
        children: formatMessage($293cf5b691bb25ab$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, $6mKj3.expVal)('confluence_space_icon_update', 'isEnabled', false) ? (0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
        testId: 'create-menu-button-item',
        Wrapper: PreloadSpaceWrap
    };
}
module.exports["useSpaceItem"] = $293cf5b691bb25ab$export$4adf07b2777336fa;

});

parcelRegister("hbYDZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842815f2fb3ef87$var$_react = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("42omo")));

var $c842815f2fb3ef87$var$_baseNew = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c842815f2fb3ef87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c842815f2fb3ef87$var$SpacesIcon = (props)=>/*#__PURE__*/ $c842815f2fb3ef87$var$_react.default.createElement($c842815f2fb3ef87$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$c842815f2fb3ef87$var$SpacesIcon.displayName = 'SpacesIcon';
var $c842815f2fb3ef87$var$_default = module.exports.default = $c842815f2fb3ef87$var$SpacesIcon;

});

parcelRegister("bAyaS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $9zUhf.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;
module.exports["SYSTEM_ADMIN_SITE_ADMINISTRATION_SECURITY"] = $0673dc41d4591954$export$a7876e82ed48f038;

});

parcelRegister("4vyfK", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");


var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $iEfsZ = parcelRequire("iEfsZ");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null } = {}) {
    if (!contentId && spaceKey) return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return (0, $dYU3e.query)({
            query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                spaceKey: spaceKey,
                version: version
            }
        }).then(({ data: data })=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
                query: (0, $iEfsZ.default),
                variables: {
                    location: Array.isArray(location) ? null : location,
                    locations: Array.isArray(location) ? location : [],
                    contentId: data?.space?.homepageId,
                    spaceKey: null,
                    version: version
                },
                data: {
                    webItemSections: data?.space?.homepageWebSections || []
                }
            });
        });
    })();
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    return (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables
    });
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<ed760a61c0c4025dac1c4e0b43c3297f>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("dYU3e", function(module, exports) {

var $4JHZe = parcelRequire("4JHZe");



var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");



var $9wGTI = parcelRequire("9wGTI");



var $7Lnfv = parcelRequire("7Lnfv");



var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT }) {
    if (!client) // Referencing to the client via global variable to avoid circular dependency
    // This should never happen and will be removed in the future
    return Promise.resolve((0, $7Lnfv.UNEXPECTED_RESPONSE));
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    let single = true;
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch(true)
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client.__isAGGClient === true;
    const queryContext = {
        single: single,
        ...context
    };
    // Only add atl-attribution header if AGG migration feature gate is enabled
    if ((0, $9wGTI.fg)('cc-agg-migration-use-agg-endpoint')) queryContext.headers = {
        ...context?.headers || {},
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    // Save current boundary context
    const currentBoundary = window.__PRELOAD_BOUNDARY_NAME__;
    // TODO: CCE2EPERF-926 needs to be updated to use query interop once we are on a single Apollo client
    return (()=>{
        const _beforeResult = (0, $4JHZe.beforePreloaderAsyncCall)();
        return client.query({
            query: query,
            variables: variables,
            errorPolicy: errorPolicy,
            fetchPolicy: fetchPolicy,
            context: queryContext
        }).then((result)=>{
            (0, $4JHZe.afterPreloaderAsyncCall)(_beforeResult);
            // Restore the previous boundary context as soon as the query resolves
            window.__PRELOAD_BOUNDARY_NAME__ = currentBoundary;
            const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(result);
            return {
                ...result,
                hasErrors: hasErrors
            };
        });
    })();
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeQuery"] = $48ba6fb41a85dc7e$export$eb834b3aa63d4199;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // graphql-tag tagged AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["UNEXPECTED_RESPONSE"] = $b5dd42974905c1cd$export$974b1060e58e0a3f;
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<fc3f514c1b8fc23b442bac6c90faf10b>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("jyA9t", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    entryPoint: 'confluenceUnknown',
    submitCallback: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: (entryPoint, spaceKey, parentContent, stagingAreaActive, content, submitCallback)=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                submitCallback: submitCallback ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                content: undefined,
                stagingAreaActive: false,
                entryPoint: 'confluenceUnknown'
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $9zUhf.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $9zUhf.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $9zUhf.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("8hdRZ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $2Yaht = parcelRequire("2Yaht");


var $jojoK = parcelRequire("jojoK");


var $6yCpa = parcelRequire("6yCpa");


var $4R3wx = parcelRequire("4R3wx");


var $f5Ulo = parcelRequire("f5Ulo");


var $9uAPw = parcelRequire("9uAPw");


var $8Q0mA = parcelRequire("8Q0mA");


var $lqy4C = parcelRequire("lqy4C");


var $dPJCf = parcelRequire("dPJCf");


var $7QM6o = parcelRequire("7QM6o");


var $lKj5W = parcelRequire("lKj5W");


var $8fj5s = parcelRequire("8fj5s");


var $9wGTI = parcelRequire("9wGTI");


var $bZSO8 = parcelRequire("bZSO8");


var $jo6R7 = parcelRequire("jo6R7");

const $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $3e0600a499c498b6$var$CROSS_JOIN = 'CROSS_JOIN';
const $3e0600a499c498b6$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.loom.title",
        defaultMessage: "Loom video"
    },
    crossJoinPopupTitle: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupTitle",
        defaultMessage: "Share your work with a video"
    },
    crossJoinPopupDescription: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossJoinCTA: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinCTA",
        defaultMessage: "Try now"
    },
    crossJoinLozenge: {
        id: "create-blank-fabric-page.universal-create.loom.cross-join-lozenge",
        defaultMessage: "Join"
    }
});
function $3e0600a499c498b6$export$5c18cb5d6208bad4(flags, error, loading, source) {
    const $ = (0, $frIzR.c)(21);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const href = (0, $f5Ulo.useLoomCrossJoinUrl)();
    let t0;
    if ($[0] !== flags || $[1] !== formatMessage || $[2] !== source) {
        t0 = (t1)=>{
            const { children: children } = t1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
                description: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupDescription),
                entryPointId: "loom-confluence-create-menu",
                sourceComponent: source,
                shouldRenderToParent: false,
                title: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupTitle),
                sourceActionSubjectId: "createLoomPopoverItem",
                triggerLink: (_, triggerProps)=>children({
                        triggerProps: triggerProps
                    }),
                flags: (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? flags : undefined
            });
        };
        $[0] = flags;
        $[1] = formatMessage;
        $[2] = source;
        $[3] = t0;
    } else t0 = $[3];
    const PopupWrapper = t0;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:loom-cross-join");
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== error || $[6] !== href || $[7] !== loading) {
        t2 = !(0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") && !error && !loading && {
            href: href
        };
        $[5] = error;
        $[6] = href;
        $[7] = loading;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== formatMessage) {
        t3 = formatMessage($3e0600a499c498b6$var$messages.crossJoinLozenge);
        $[9] = formatMessage;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== formatMessage) {
        t4 = formatMessage($3e0600a499c498b6$var$messages.title);
        $[11] = formatMessage;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t3 || $[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jo6R7.ItemTitleWithLozenge), {
            lozenge: t3
        }, t4);
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== PopupWrapper || $[17] !== loading || $[18] !== t2 || $[19] !== t5) {
        t6 = {
            ati: t1,
            ...t2,
            isLoading: loading,
            target: "_blank",
            testId: "create-menu-link-item",
            children: t5,
            Wrapper: PopupWrapper,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht)))
        };
        $[16] = PopupWrapper;
        $[17] = loading;
        $[18] = t2;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
}
const $3e0600a499c498b6$export$3bdf8358f565b3a3 = (t0)=>{
    const $ = (0, $frIzR.c)(39);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick, flags: flags } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== flags) {
        t1 = {
            entryPointLocation: $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE,
            flags: flags
        };
        $[0] = flags;
        $[1] = t1;
    } else t1 = $[1];
    const { openLoomRecorder: openLoomRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized, hasRecordingAccess: hasRecordingAccess } = (0, $9uAPw.useLoomRecorderEntryPoint)(t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "record-loom-popover-item"
        };
        $[2] = t2;
    } else t2 = $[2];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t2);
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== onClick || $[5] !== openLoomRecorder || $[6] !== parentId || $[7] !== push || $[8] !== source || $[9] !== spaceId || $[10] !== spaceKey) {
        t3 = ()=>{
            onClick("createLoomPopoverItem");
            openLoomRecorder({
                onInsert: (videoUrl)=>{
                    const createUrl = (0, $bZSO8.buildCreationLink)({
                        contentType: "smartLinkEmbed",
                        parentPageId: parentId,
                        withFallback: true,
                        smartLinkCreateSource: "loomRecordSDK",
                        smartLinkEmbedUrl: videoUrl,
                        source: source,
                        spaceKey: spaceKey
                    });
                    push(createUrl);
                    (0, $jojoK.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                        createAnalyticsEvent({
                            type: "sendTrackEvent",
                            data: {
                                action: "insertVideo",
                                actionSubject: "loom",
                                source: source,
                                objectType: "embed",
                                containerType: "space",
                                containerId: spaceId,
                                attributes: {
                                    location: "contentTreeItem",
                                    video_id: hashedVideoId
                                }
                            }
                        }).fire();
                    });
                },
                insertButtonText: "Insert video",
                location: "topNav"
            });
        };
        $[3] = createAnalyticsEvent;
        $[4] = onClick;
        $[5] = openLoomRecorder;
        $[6] = parentId;
        $[7] = push;
        $[8] = source;
        $[9] = spaceId;
        $[10] = spaceKey;
        $[11] = t3;
    } else t3 = $[11];
    const handleClick = t3;
    let t4;
    if ($[12] !== hasRecordingAccess || $[13] !== isLoomRecorderInitialized) {
        t4 = isLoomRecorderInitialized && hasRecordingAccess && (0, $9wGTI.fg)("confluence_m25_onboarding_spotlights");
        $[12] = hasRecordingAccess;
        $[13] = isLoomRecorderInitialized;
        $[14] = t4;
    } else t4 = $[14];
    const shouldShowLoomGAOnboarding = t4;
    const [isLoomGAOnboardingActive, stopLoomGAOnboarding] = (0, $8fj5s.useSkippableCoordination)("cc-loom-onboarding-spotlight-creation", !shouldShowLoomGAOnboarding || shouldBlockCreate);
    const [isGASpotlightOpen, setIsGASpotlightOpen] = (0, $42omo.useState)(true);
    let t5;
    if ($[15] !== isLoomGAOnboardingActive || $[16] !== stopLoomGAOnboarding) {
        t5 = ()=>{
            if (isLoomGAOnboardingActive) {
                setIsGASpotlightOpen(false);
                stopLoomGAOnboarding();
            }
        };
        $[15] = isLoomGAOnboardingActive;
        $[16] = stopLoomGAOnboarding;
        $[17] = t5;
    } else t5 = $[17];
    const handleSpotlightClose = t5;
    let t6;
    if ($[18] !== enforceStorageLimit || $[19] !== handleClick || $[20] !== handleSpotlightClose || $[21] !== source) {
        t6 = (t7)=>{
            const { children: children } = t7;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lKj5W.RecordLoomPopoverItemSpotlight), {
                onRecord: enforceStorageLimit(handleClick),
                onClose: handleSpotlightClose,
                source: source,
                shouldWatchTarget: true
            }, children());
        };
        $[18] = enforceStorageLimit;
        $[19] = handleClick;
        $[20] = handleSpotlightClose;
        $[21] = source;
        $[22] = t6;
    } else t6 = $[22];
    const RecordLoomSpotlightWrapper = t6;
    let t7;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:video");
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== formatMessage) {
        t8 = formatMessage($3e0600a499c498b6$var$messages.title);
        $[24] = formatMessage;
        $[25] = t8;
    } else t8 = $[25];
    const t9 = !isLoomRecorderInitialized;
    let t10;
    if ($[26] !== enforceStorageLimit || $[27] !== handleClick) {
        t10 = enforceStorageLimit(handleClick);
        $[26] = enforceStorageLimit;
        $[27] = handleClick;
        $[28] = t10;
    } else t10 = $[28];
    let t11;
    if ($[29] !== RecordLoomSpotlightWrapper || $[30] !== isGASpotlightOpen || $[31] !== isLoomGAOnboardingActive || $[32] !== shouldShowLoomGAOnboarding) {
        t11 = shouldShowLoomGAOnboarding && isLoomGAOnboardingActive && isGASpotlightOpen && {
            Wrapper: RecordLoomSpotlightWrapper
        };
        $[29] = RecordLoomSpotlightWrapper;
        $[30] = isGASpotlightOpen;
        $[31] = isLoomGAOnboardingActive;
        $[32] = shouldShowLoomGAOnboarding;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== t10 || $[35] !== t11 || $[36] !== t8 || $[37] !== t9) {
        t12 = {
            ati: t7,
            children: t8,
            isLoading: t9,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))),
            testId: "create-menu-button-item",
            onClick: t10,
            ...t11
        };
        $[34] = t10;
        $[35] = t11;
        $[36] = t8;
        $[37] = t9;
        $[38] = t12;
    } else t12 = $[38];
    return t12;
};
function $3e0600a499c498b6$export$2c423d86f10c527b(props) {
    const { entryPointVariant: entryPointVariant, error: error, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const recordItem = $3e0600a499c498b6$export$3bdf8358f565b3a3(props);
    const crossJoinItem = $3e0600a499c498b6$export$5c18cb5d6208bad4(props.flags, error, loading, props.source);
    return entryPointVariant === $3e0600a499c498b6$var$CROSS_JOIN ? crossJoinItem : recordItem;
}
module.exports["useLoomItem"] = $3e0600a499c498b6$export$2c423d86f10c527b;

});

parcelRegister("jojoK", function(module, exports) {
const $6eadce97261b744f$var$LOOM_URL_REGEX = // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
function $6eadce97261b744f$var$extractLoomVideoId(url) {
    const match = url.match($6eadce97261b744f$var$LOOM_URL_REGEX);
    return match?.groups?.videoId;
}
async function $6eadce97261b744f$var$digestMessage(message) {
    // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
    if (window?.crypto?.subtle?.digest) {
        const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        return hashHex;
    }
    return '';
}
async function $6eadce97261b744f$export$495fb2ecc80ca6c0(url) {
    try {
        const videoId = $6eadce97261b744f$var$extractLoomVideoId(url);
        if (videoId) {
            const data = atob('c2U1UTwgekZlVEYkP1MzRno1QmV5WXBoSE13SHg8RWpjM10saHJQZmhPMVVHKHM=') + videoId;
            const digestHex = await $6eadce97261b744f$var$digestMessage(data);
            return digestHex ? `vidhash-${digestHex}` : '';
        }
        return '';
    } catch (_) {
        return '';
    }
}
module.exports["getHashedLoomVideoIdFromUrl"] = $6eadce97261b744f$export$495fb2ecc80ca6c0;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== activationId || $[3] !== cloudId) {
        t1 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[2] = activationId;
        $[3] = cloudId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = {
            headers: {
                ...t1
            }
        };
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t4;
    if ($[7] !== t0 || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            variables: t0,
            context: t2,
            skip: t3
        };
        $[7] = t0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, t4);
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<b0fb41d42738db4128917afea956b213>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $42omo.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<e139440afb86fce20d0d7fdd22b96ac3>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $9wGTI.fg)("use_frontend_feature_encoding_sdk") ? (0, $5spQU.isFeatureEnabled)("confluence", "confluence-loom-integration") : !isInFedRamp;
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    // When the gate is ON, we use the feature-encoding SDK to check if the feature is enabled in the current environment
    const isLoomFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration') : !isInFedRamp;
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("a26i4", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $h7YX1 = parcelRequire("h7YX1");


var $gNXND = parcelRequire("gNXND");


var $6yCpa = parcelRequire("6yCpa");


var $16lEl = parcelRequire("16lEl");

var $hUyPY = parcelRequire("hUyPY");


var $6mKj3 = parcelRequire("6mKj3");


var $dDAsV = parcelRequire("dDAsV");


var $jyA9t = parcelRequire("jyA9t");


var $b8pRY = parcelRequire("b8pRY");


var $cbBHq = parcelRequire("cbBHq");


var $1NBp8 = parcelRequire("1NBp8");


var $9wGTI = parcelRequire("9wGTI");


var $eB1TF = parcelRequire("eB1TF");


var $jo6R7 = parcelRequire("jo6R7");


var $85eZj = parcelRequire("85eZj");

const $03068ae1a528f6bf$var$i18n = (0, $cgtv4.defineMessages)({
    smartCreateTitle: {
        id: "create-blank-fabric-page.create.content.smart-create-with-ai.title",
        defaultMessage: "Create with Rovo"
    },
    smartCreateWithAiTitle: {
        id: "create-blank-fabric-page.create.content.smart-create-with-rovo-ai.title",
        defaultMessage: "Create with Rovo AI"
    }
});
const $03068ae1a528f6bf$var$getSpaceKeyForCreation = async ()=>{
    const spaceKeyRequest = {
        promotedSpaceKey: undefined
    };
    const spaceKeyResponse = (await (0, $dDAsV.experimentalPromotedSpacesQuery)({
        variables: {
            ...spaceKeyRequest,
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1
        }
    })).data;
    return spaceKeyResponse?.experimentalPromotedSpaces?.nodes?.[0]?.id ?? '';
};
function $03068ae1a528f6bf$export$57669fd702f839a2(t0) {
    const $ = (0, $frIzR.c)(31);
    const { spaceKey: spaceKey, onClick: onClick, source: source } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const preloadSmartCreationModal = (0, $cbBHq.usePreloadSmartCreationModal)();
    const [fetchedSpaceKey, setFetchedSpaceKey] = (0, $42omo.useState)("");
    const [spaceKeyLoading, setSpaceKeyLoading] = (0, $42omo.useState)(true);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setSpaceKeyLoading(true);
            $03068ae1a528f6bf$var$getSpaceKeyForCreation().then(setFetchedSpaceKey).finally(()=>setSpaceKeyLoading(false));
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] !== isOpen || $[3] !== preloadSmartCreationModal) {
        t3 = ()=>{
            if (isOpen) preloadSmartCreationModal();
        };
        t4 = [
            isOpen,
            preloadSmartCreationModal
        ];
        $[2] = isOpen;
        $[3] = preloadSmartCreationModal;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[6] !== experienceTracker || $[7] !== fetchedSpaceKey || $[8] !== openModal || $[9] !== source || $[10] !== spaceKey) {
        t5 = ()=>{
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                id: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                attributes: {
                    product: "confluence",
                    source: source
                }
            });
            openModal(source, spaceKey ?? fetchedSpaceKey);
        };
        $[6] = experienceTracker;
        $[7] = fetchedSpaceKey;
        $[8] = openModal;
        $[9] = source;
        $[10] = spaceKey;
        $[11] = t5;
    } else t5 = $[11];
    const handleOpenCreateWithRovoExperience = t5;
    let t6;
    if ($[12] !== handleOpenCreateWithRovoExperience || $[13] !== onClick) {
        t6 = (e, actionSubjectId, attributes)=>{
            onClick(actionSubjectId, attributes);
            if (e?.metaKey || e?.ctrlKey) return;
            e.preventDefault();
            handleOpenCreateWithRovoExperience();
        };
        $[12] = handleOpenCreateWithRovoExperience;
        $[13] = onClick;
        $[14] = t6;
    } else t6 = $[14];
    const handleItemOnClick = t6;
    let t7;
    if ($[15] !== handleOpenCreateWithRovoExperience || $[16] !== source || $[17] !== spaceKeyLoading) {
        t7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85eZj.AnimatedGradientBorder), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b8pRY.UniversalCreateWithRovoSpotlight), {
                onClick: ()=>handleOpenCreateWithRovoExperience(),
                isLoading: spaceKeyLoading,
                source: source
            }, props.children && props.children()));
        $[15] = handleOpenCreateWithRovoExperience;
        $[16] = source;
        $[17] = spaceKeyLoading;
        $[18] = t7;
    } else t7 = $[18];
    const CreateWithRovoSpotlightWrapper = t7;
    let t8;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $1NBp8.HOME).toUrl({}, {
            query: {
                openCreateWithRovo: "true"
            }
        });
        $[19] = t8;
    } else t8 = $[19];
    const href = t8;
    let t9;
    if ($[20] !== formatMessage) {
        t9 = ()=>{
            const message = (0, $6mKj3.expValEquals)("cc_fd_aifc_copy_change_experiment", "isEnabled", true) ? $03068ae1a528f6bf$var$i18n.smartCreateWithAiTitle : $03068ae1a528f6bf$var$i18n.smartCreateTitle;
            if ((0, $9wGTI.fg)("aifc_onboarding_ga_enabled")) {
                if ((0, $6mKj3.expValEquals)("cc-aifc-databases-experiment", "isEnabled", true)) return formatMessage(message);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jo6R7.ItemTitleWithLozenge), {
                useLabsLozenge: true
            }, formatMessage(message));
        };
        $[20] = formatMessage;
        $[21] = t9;
    } else t9 = $[21];
    const getChildren = t9;
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:page");
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== getChildren) {
        t11 = getChildren();
        $[23] = getChildren;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== handleItemOnClick) {
        t12 = (e_0)=>handleItemOnClick(e_0, "createAISmartCreatePopoverItem");
        $[25] = handleItemOnClick;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== CreateWithRovoSpotlightWrapper || $[28] !== t11 || $[29] !== t12) {
        t13 = {
            ati: t10,
            children: t11,
            Wrapper: CreateWithRovoSpotlightWrapper,
            onClick: t12,
            href: href,
            elemBefore: (0, $6mKj3.expValEquals)("cc_fd_aifc_copy_change_experiment", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($gNXND))) : (0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))),
            testId: "create-menu-link-item"
        };
        $[27] = CreateWithRovoSpotlightWrapper;
        $[28] = t11;
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    return t13;
}
module.exports["useAISmartCreateItem"] = $03068ae1a528f6bf$export$57669fd702f839a2;

});

parcelRegister("gNXND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf9be9856ff4d9$var$_react = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3bf9be9856ff4d9$var$_baseNew = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3bf9be9856ff4d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf9be9856ff4d9$var$RovoIcon = (props)=>/*#__PURE__*/ $c3bf9be9856ff4d9$var$_react.default.createElement($c3bf9be9856ff4d9$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$c3bf9be9856ff4d9$var$RovoIcon.displayName = 'RovoIcon';
var $c3bf9be9856ff4d9$var$_default = module.exports.default = $c3bf9be9856ff4d9$var$RovoIcon;

});

parcelRegister("b8pRY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cSCao = parcelRequire("cSCao");

const $a873bb1c9107ef25$export$8432db7340d3c5cd = ({ onClick: onClick, isLoading: isLoading, source: source, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSCao.AISmartCreateSpotlight), {
        onClick: onClick,
        offset: [
            0,
            16
        ],
        placement: "left-end",
        source: source,
        isLoading: isLoading
    }, children);
};
module.exports["UniversalCreateWithRovoSpotlight"] = $a873bb1c9107ef25$export$8432db7340d3c5cd;

});

parcelRegister("cbBHq", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ 
var $42omo = parcelRequire("42omo");


var $lvOsp = parcelRequire("lvOsp");


var $9wGTI = parcelRequire("9wGTI");


var $2PxwR = parcelRequire("2PxwR");


var $6gwjd = parcelRequire("6gwjd");

const $0b3da77a55c8d66c$export$47d6a944ca09299 = ()=>{
    const [preloadSmartCreationModalQuery] = (0, $lvOsp.useLazyQueryInterop)((0, $6gwjd.default));
    return (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('aifc_create_enabled')) {
            preloadSmartCreationModalQuery();
            (0, $2PxwR.LazyConfluenceSmartCreationModal).preload();
        }
    }, [
        preloadSmartCreationModalQuery
    ]);
};
module.exports["usePreloadSmartCreationModal"] = $0b3da77a55c8d66c$export$47d6a944ca09299;

});

parcelRegister("lvOsp", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jxs8y = parcelRequire("jxs8y");


var $86okN = parcelRequire("86okN");

const $278c8d04dad7bc1d$export$363a8d7f501f3769 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryInterop(query, options) {
    const $ = (0, $frIzR.c)(2);
    {
        let t0;
        if ($[0] !== query) {
            t0 = (0, $86okN.toDocumentNode)(query);
            $[0] = query;
            $[1] = t0;
        } else t0 = $[1];
        return (0, $jxs8y.useLazyQuery)(t0, options);
    }
} : function useLazyQueryInterop(query, options) {
    return (0, $jxs8y.useLazyQuery)((0, $86okN.toDocumentNode)(query), options);
};
module.exports["useLazyQueryInterop"] = $278c8d04dad7bc1d$export$363a8d7f501f3769;

});

parcelRegister("2PxwR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c156286aa1d634b0$export$116ded32e65c3603 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4mwBk",
    name: "LazyConfluenceSmartCreationModal",
    loader: async ()=>(await (parcelRequire("9QPc6"))).ConfluenceSmartCreationModal
});
module.exports["LazyConfluenceSmartCreationModal"] = $c156286aa1d634b0$export$116ded32e65c3603;

});

parcelRegister("9QPc6", function(module, exports) {

let $72c0ae79609cb369$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $72c0ae79609cb369$var$load("8aI1S"),
    $72c0ae79609cb369$var$load("GuKfo"),
    $72c0ae79609cb369$var$load("5ZwKh"),
    $72c0ae79609cb369$var$load("iqKwT"),
    $72c0ae79609cb369$var$load("kUbUu"),
    $72c0ae79609cb369$var$load("h3ABO"),
    $72c0ae79609cb369$var$load("bGCo4"),
    $72c0ae79609cb369$var$load("gtFyW"),
    $72c0ae79609cb369$var$load("iqTGf"),
    $72c0ae79609cb369$var$load("cUIaj"),
    $72c0ae79609cb369$var$load("76iIp"),
    $72c0ae79609cb369$var$load("az9CK"),
    $72c0ae79609cb369$var$load("2YffH"),
    $72c0ae79609cb369$var$load("fACU5"),
    $72c0ae79609cb369$var$load("1V5kR"),
    $72c0ae79609cb369$var$load("d4FBX"),
    $72c0ae79609cb369$var$load("6CsV3"),
    $72c0ae79609cb369$var$load("1P7J4"),
    $72c0ae79609cb369$var$load("5Y2To"),
    $72c0ae79609cb369$var$load("fGTig"),
    $72c0ae79609cb369$var$load("hXXVg"),
    $72c0ae79609cb369$var$load("fJtJG"),
    $72c0ae79609cb369$var$load("1GvGi"),
    $72c0ae79609cb369$var$load("d4u0p"),
    $72c0ae79609cb369$var$load("cAi0E"),
    $72c0ae79609cb369$var$load("8Vm0B"),
    $72c0ae79609cb369$var$load("6QICh"),
    $72c0ae79609cb369$var$load("gVbhn"),
    $72c0ae79609cb369$var$load("eBY1U"),
    $72c0ae79609cb369$var$load("dUz9k"),
    $72c0ae79609cb369$var$load("cyGuT"),
    $72c0ae79609cb369$var$load("2NUMk"),
    $72c0ae79609cb369$var$load("4OTrY"),
    $72c0ae79609cb369$var$load("9XYQ9"),
    $72c0ae79609cb369$var$load("3EXzu"),
    $72c0ae79609cb369$var$load("jMj86"),
    $72c0ae79609cb369$var$load("b2FtX"),
    $72c0ae79609cb369$var$load("9Xam1"),
    $72c0ae79609cb369$var$load("3w411"),
    $72c0ae79609cb369$var$load("eY3St"),
    $72c0ae79609cb369$var$load("bkd4T"),
    $72c0ae79609cb369$var$load("atfX6"),
    $72c0ae79609cb369$var$load("jYaxE"),
    $72c0ae79609cb369$var$load("855o0"),
    $72c0ae79609cb369$var$load("8MfZE"),
    $72c0ae79609cb369$var$load("6wr18"),
    $72c0ae79609cb369$var$load("kjZZD"),
    $72c0ae79609cb369$var$load("ht5OT"),
    $72c0ae79609cb369$var$load("sj9Xz"),
    $72c0ae79609cb369$var$load("Wowvf"),
    $72c0ae79609cb369$var$load("ffEVr"),
    $72c0ae79609cb369$var$load("hhss7"),
    $72c0ae79609cb369$var$load("hGfPD"),
    $72c0ae79609cb369$var$load("7Gmjr"),
    $72c0ae79609cb369$var$load("6u1hm"),
    $72c0ae79609cb369$var$load("5JyhW"),
    $72c0ae79609cb369$var$load("Br0Hw"),
    $72c0ae79609cb369$var$load("3GR0Y"),
    $72c0ae79609cb369$var$load("bgHzk"),
    $72c0ae79609cb369$var$load("7EorR"),
    $72c0ae79609cb369$var$load("fQKYr")
]).then(()=>parcelRequire('6CLTo'));

});

parcelRegister("6gwjd", function(module, exports) {
/**
 * @generated SignedSource<<3713f9ef4d56463a35a603e84cf10cea>>
 * @relayHash e04a1fbd9772100897718d8eb52d327f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641
const $7b2c6142b984d24d$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e04a1fbd9772100897718d8eb52d327f",
            "id": "29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641",
            "metadata": {},
            "name": "ConfluenceSmartCreationModalQuery",
            "operationKind": "query",
            "text": "query ConfluenceSmartCreationModalQuery{user:confluence_atlassianUser(current:true){id,title}}"
        }
    };
}();
$7b2c6142b984d24d$var$node.hash = "b82822dc05785ac3b5e50c2feec2f4f2";
var $7b2c6142b984d24d$export$2e2bcd8739ae039 = $7b2c6142b984d24d$var$node;
module.exports["default"] = $7b2c6142b984d24d$export$2e2bcd8739ae039;

});

parcelRegister("2JWbn", function(module, exports) {

let $1fecea9067ac92d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1fecea9067ac92d1$var$load("3GR0Y"),
    $1fecea9067ac92d1$var$load("a7NC3"),
    $1fecea9067ac92d1$var$load("kFEyO"),
    $1fecea9067ac92d1$var$load("d4FBX"),
    $1fecea9067ac92d1$var$load("jYaxE"),
    $1fecea9067ac92d1$var$load("hhss7"),
    $1fecea9067ac92d1$var$load("6u1hm"),
    $1fecea9067ac92d1$var$load("9ftJe"),
    $1fecea9067ac92d1$var$load("7EorR"),
    $1fecea9067ac92d1$var$load("3fgvt")
]).then(()=>parcelRequire('dAcK0'));

});

parcelRegister("3r6hw", function(module, exports) {

let $2808c41f5bb2532f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2808c41f5bb2532f$var$load("8HgfY"),
    $2808c41f5bb2532f$var$load("5JyhW"),
    $2808c41f5bb2532f$var$load("Br0Hw"),
    $2808c41f5bb2532f$var$load("3GR0Y"),
    $2808c41f5bb2532f$var$load("6wr18"),
    $2808c41f5bb2532f$var$load("2Dtn6"),
    $2808c41f5bb2532f$var$load("e1fGs"),
    $2808c41f5bb2532f$var$load("3VpLA"),
    $2808c41f5bb2532f$var$load("a7NC3"),
    $2808c41f5bb2532f$var$load("kFEyO"),
    $2808c41f5bb2532f$var$load("d4FBX"),
    $2808c41f5bb2532f$var$load("jYaxE"),
    $2808c41f5bb2532f$var$load("ffEVr"),
    $2808c41f5bb2532f$var$load("hhss7"),
    $2808c41f5bb2532f$var$load("6u1hm"),
    $2808c41f5bb2532f$var$load("9ftJe"),
    $2808c41f5bb2532f$var$load("7EorR"),
    $2808c41f5bb2532f$var$load("4XUbE")
]).then(()=>parcelRequire('7aarm'));

});

parcelRegister("2Nwuj", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

const $0412590977f134ac$var$styles = {
    base: "_ect4ttxp",
    baseT26Shape: "_2rkolb4i",
    visitedLink: "_10531ra0 _1ien1ra0 _n0fx1ra0 _1vhv17z1",
    defaultAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz13af _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj13af _9oik1r31 _1bnxglyw _jf4cnqa1 _30l313af _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h12zz",
    subtleAppearance: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _syazazsu _1a3b1r31 _4fprglyw _5goinqa1 _f8pjazsu _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3azsu _1nrm1r31 _c2wa8stv _1iohnqa1 _9h8hi7uo",
    inverseAppearance: "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz15cr _105315cr _1a3b1r31 _4fpr8stv _5goinqa1 _f8pj15cr _9oik1r31 _1bnxglyw _jf4cnqa1 _30l315cr _1nrm1r31 _c2waglyw _1iohnqa1 _9h8h15cr",
    iconWrapper: "_1e0c1nu9 _o5721q9c _s7n41q9y _kqswh2mm _152ttb3r"
};
const $0412590977f134ac$var$iconStyles = null;
const $0412590977f134ac$var$LinkWithoutRef = ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $1Whri.cx)($0412590977f134ac$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $0412590977f134ac$var$styles.baseT26Shape, appearance === 'default' && $0412590977f134ac$var$styles.defaultAppearance, appearance === 'subtle' && $0412590977f134ac$var$styles.subtleAppearance, appearance === 'inverse' && $0412590977f134ac$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $0412590977f134ac$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                as: "span",
                xcss: $0412590977f134ac$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $l998X.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $gMc0m.default)([
                            "_1bsbgm0b _4t3igm0b _ahbqzjw7"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    });
}; // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $0412590977f134ac$var$Link = /*#__PURE__*/ (0, $42omo.forwardRef)($0412590977f134ac$var$LinkWithoutRef);
var $0412590977f134ac$export$2e2bcd8739ae039 = $0412590977f134ac$var$Link;
module.exports["default"] = $0412590977f134ac$export$2e2bcd8739ae039;

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("3QyBm", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $4VJDS.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("k7Tf7", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $2xusd = parcelRequire("2xusd");


var $2MPqq = parcelRequire("2MPqq");

const $94cea1b432ccea5e$export$bf694c7c431c162a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2MPqq.SpotlightContextProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2xusd.Manager), {
            children: children
        })
    });
};
module.exports["PopoverProvider"] = $94cea1b432ccea5e$export$bf694c7c431c162a;

});

parcelRegister("a90ar", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $cs0ez = parcelRequire("cs0ez");

const $fcb2cc293f5cb422$export$5ad0c0856b469f13 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
        children: ({ ref: ref })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: ref,
                children: children
            })
    });
};
module.exports["PopoverTarget"] = $fcb2cc293f5cb422$export$5ad0c0856b469f13;

});

parcelRegister("3chlW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $497b092596857daa$var$styles = {
    root: "_1bsb1osq"
};
const $497b092596857daa$export$205c28213090dc52 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $497b092596857daa$var$styles.root,
        role: "group",
        justifyContent: "end",
        gap: "space.050",
        children: children
    });
});
module.exports["SpotlightActions"] = $497b092596857daa$export$205c28213090dc52;

});

parcelRegister("f1UQW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $8f17e6224eab722b$var$styles = {
    root: "_18zrpxbi _syaz15cr _1q51u2gc"
};
const $8f17e6224eab722b$export$4ae665cf62a00c3f = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: ref,
        xcss: $8f17e6224eab722b$var$styles.root,
        testId: testId,
        children: children
    });
});
module.exports["SpotlightBody"] = $8f17e6224eab722b$export$4ae665cf62a00c3f;

});

parcelRegister("71521", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $gdv5Z = parcelRequire("gdv5Z");


var $2MPqq = parcelRequire("2MPqq");


var $jEGan = parcelRequire("jEGan");

const $632f68eebac3d948$var$styles = {
    root: "_kqswh2mm",
    card: "_2rko1mok _zulpu2gc _kqswstnw _1bsbaq3k _1q51u2gc _85i5utpp _1e0c1txw _2lx21bp4 _16qs1nax"
};
const $632f68eebac3d948$var$placementStyles = {
    'top-start': "_u7co12x7 _rjxpc7mi",
    'top-center': "_u7co12x7 _1e021qz4",
    'top-end': "_u7co12x7 _1e02c7mi",
    'right-start': "_1e0212x7 _u7comgjw",
    'right-end': "_1e0212x7 _152tmgjw",
    'bottom-start': "_152t12x7 _rjxpc7mi",
    'bottom-center': "_152t12x7 _1e021qz4",
    'bottom-end': "_152t12x7 _1e02c7mi",
    'left-start': "_rjxp12x7 _u7comgjw",
    'left-end': "_rjxp12x7 _152tmgjw"
};
const $632f68eebac3d948$export$14710e13fc01d383 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { card: card } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const cardRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        card.setRef(cardRef);
    }, [
        card
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            $632f68eebac3d948$var$styles.root
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $jEGan.Caret), {}),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                ref: cardRef,
                backgroundColor: "color.background.neutral.bold",
                xcss: (0, $1Whri.cx)($632f68eebac3d948$var$styles.card, $632f68eebac3d948$var$placementStyles[card.placement]),
                children: children
            })
        ]
    });
});
module.exports["SpotlightCard"] = $632f68eebac3d948$export$14710e13fc01d383;

});

parcelRegister("jEGan", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $2MPqq = parcelRequire("2MPqq");

const $8ca37cde5226694e$var$styles = {
    root: "_bfhk1aqn _mkrzmhja _4t3io7ao _kqswh2mm _1bsbo7ao _1pby1fw0",
    'top-start': "_t9ec71a3",
    'top-center': "_t9ec71a3",
    'top-end': "_t9ec71a3",
    'bottom-start': "_t9ec1hke",
    'bottom-center': "_t9ec1hke",
    'bottom-end': "_t9ec1hke",
    'right-start': "_t9ecjyd4",
    'right-end': "_t9ecjyd4",
    'left-start': "_t9ecebzf",
    'left-end': "_t9ecebzf"
};
const $8ca37cde5226694e$export$88fca06e22f21720 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId }, ref)=>{
    const { card: card } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            borderEndStartRadius: '1px'
        },
        className: (0, $gMc0m.default)([
            $8ca37cde5226694e$var$styles.root,
            $8ca37cde5226694e$var$styles[card.placement]
        ])
    });
});
module.exports["Caret"] = $8ca37cde5226694e$export$88fca06e22f21720;

});

parcelRegister("eopLP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $c18394162d9dc107$var$styles = {
    root: "_bozgpxbi _y4tiutpp _1bsb1osq"
};
const $c18394162d9dc107$export$f76dbc85ba76ccc2 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $c18394162d9dc107$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        children: children
    });
});
module.exports["SpotlightFooter"] = $c18394162d9dc107$export$f76dbc85ba76ccc2;

});

parcelRegister("aZQ5F", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");

const $ad24be9a70db7ad2$var$styles = {
    root: "_bozgpxbi _y4tiutpp"
};
const $ad24be9a70db7ad2$export$d646029b3ba8ab76 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ref: ref,
        testId: testId,
        xcss: $ad24be9a70db7ad2$var$styles.root,
        alignItems: "center",
        justifyContent: "space-between",
        gap: "space.100",
        children: children
    });
});
module.exports["SpotlightHeader"] = $ad24be9a70db7ad2$export$d646029b3ba8ab76;

});

parcelRegister("fNcP1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $2MPqq = parcelRequire("2MPqq");

const $456a9b1f10f70d47$var$styles = {
    root: "_2rko12b0 _1dqonqa1 _189ee4h9 _1h6d8yml _syaz15cr _bfhk1aqn _irr31ibz _1di6of27"
};
const $456a9b1f10f70d47$export$eea27caf91a85655 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-label': ariaLabel, onClick: onClick, children: children, testId: testId }, ref)=>{
    const { primaryAction: primaryAction } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const done = (event)=>{
        primaryAction.action.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        "aria-label": ariaLabel,
        ref: ref,
        testId: testId,
        xcss: $456a9b1f10f70d47$var$styles.root,
        onClick: onClick || done,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            as: "span",
            children: children
        })
    });
});
module.exports["SpotlightPrimaryAction"] = $456a9b1f10f70d47$export$eea27caf91a85655;

});

parcelRegister("aVS0S", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $b2d7675e2e3d4813$var$styles = {
    root: "_zulpu2gc _1e0c1txw _2lx21sbv"
};
const $b2d7675e2e3d4813$export$67fb68d4ebe55a86 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        ref: ref,
        role: "group",
        className: (0, $gMc0m.default)([
            $b2d7675e2e3d4813$var$styles.root
        ]),
        children: children
    });
});
module.exports["SpotlightControls"] = $b2d7675e2e3d4813$export$67fb68d4ebe55a86;

});

parcelRegister("2owmo", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $hmuev = parcelRequire("hmuev");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $2MPqq = parcelRequire("2MPqq");

const $e90e33f81b492555$var$styles = {
    root: "_2rko12b0 _1rjc12x7 _syaz15cr _bfhk1aqn _irr31ibz _1di6of27",
    rootT26Shape: "_2rko1qi0"
};
const $e90e33f81b492555$export$4eef19754b0d485e = /*#__PURE__*/ (0, $42omo.forwardRef)(({ autoFocus: autoFocus = true, onClick: onClick, testId: testId }, ref)=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const dismiss = (event)=>{
        popoverContent.dismiss.current(event);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        autoFocus: autoFocus,
        onClick: onClick || dismiss,
        ref: ref,
        testId: testId,
        xcss: (0, $1Whri.cx)($e90e33f81b492555$var$styles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $e90e33f81b492555$var$styles.rootT26Shape),
        "aria-label": "Dismiss",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: "Close"
        })
    });
});
module.exports["SpotlightDismissControl"] = $e90e33f81b492555$export$4eef19754b0d485e;

});

parcelRegister("bUJpY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $cO1el = parcelRequire("cO1el");


var $2MPqq = parcelRequire("2MPqq");

const $7a1f3efc02714981$export$b57275b1b6b9863b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    const { heading: heading } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
        id: heading.id,
        ref: ref,
        testId: testId,
        size: "xsmall",
        children: children
    });
});
module.exports["SpotlightHeadline"] = $7a1f3efc02714981$export$b57275b1b6b9863b;

});

parcelRegister("fdtRy", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $5df9daaf2c005ad4$var$styles = {
    root: "_1reo15vq _18m915vq _1bsbaq3k _4t3ihcro"
};
const $5df9daaf2c005ad4$export$cf33151c3f01cd9a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        ref: ref,
        xcss: $5df9daaf2c005ad4$var$styles.root,
        testId: testId,
        children: children
    });
});
module.exports["SpotlightMedia"] = $5df9daaf2c005ad4$export$cf33151c3f01cd9a;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function') // dont use finally as it "multiplies" rejected promises
        result.then($568c54c2a75aa99b$export$a775919ebd7dd28a.clear, $568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (inj) {
        var _inj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === inj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(inj, new Error(`Unused "di" injectable: ${((_inj$value = inj.value) == null ? void 0 : _inj$value.displayName) || inj.value}.`, {
            cause: inj.cause
        }));
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
        // reset to avoid potential memory leaks via stack traces
        inj.cause = null;
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("lwNi3", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $04e9M = parcelRequire("04e9M");


var $jOtRZ = parcelRequire("jOtRZ");


var $lBR3p = parcelRequire("lBR3p");

const $5efec5cf952678ca$export$ddc368dc94a41e62 = (withChoreographer = true)=>{
    const { cloudId: cloudId, activationId: activationId, environment: environment } = (0, $bQm3c.useSessionData)();
    const workspaceId = (0, $04e9M.getWorkspaceId)(cloudId, activationId);
    const disableEngagementForTests = sessionStorage.getItem('confluence.disable-engagement-for-tests') === 'true';
    const envType = (0, $jOtRZ.useAnalyticsEnvironment)(environment);
    return (0, $42omo.useMemo)(()=>(0, $lBR3p.getCoordinationClient)(disableEngagementForTests, cloudId, workspaceId, withChoreographer, envType), [
        disableEngagementForTests,
        cloudId,
        workspaceId,
        withChoreographer,
        envType
    ]);
};
module.exports["useCoordinationClient"] = $5efec5cf952678ca$export$ddc368dc94a41e62;

});

parcelRegister("lBR3p", function(module, exports) {

var $5loD0 = parcelRequire("5loD0");


var $fw9LG = parcelRequire("fw9LG");

const $b379edbfb382bc54$var$noop = async ()=>false;
const $b379edbfb382bc54$export$a3f969ef7d35205d = (disableEngagementForTests, cloudId, workspaceId, enableChoreographer, environment)=>{
    if (disableEngagementForTests) return {
        start: $b379edbfb382bc54$var$noop,
        stop: $b379edbfb382bc54$var$noop
    };
    else {
        const coordinationOptions = {
            enableChoreographer: enableChoreographer,
            envType: environment,
            additionalData: {
                sourceProductId: (0, $fw9LG.ProductIds).CONFLUENCE
            }
        };
        return new (0, $5loD0.default)({
            cloudId: cloudId,
            stargateUrl: '/gateway/api',
            isFedRAMPEnvironment: false,
            workspaceId: workspaceId,
            coordinationOptions: coordinationOptions
        });
    }
};
module.exports["getCoordinationClient"] = $b379edbfb382bc54$export$a3f969ef7d35205d;

});

parcelRegister("5loD0", function(module, exports) {

var $ll2sR = parcelRequire("ll2sR");


var $4nGsu = parcelRequire("4nGsu");

class $4b61f610720049a6$export$2e2bcd8739ae039 {
    async start(messageId, variationId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.startMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            variationId: variationId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    async stop(messageId) {
        if (!(0, $4nGsu.isMessagingEnabled)()) return false;
        return (0, $ll2sR.stopMessage)({
            cloudId: this.cloudId,
            stargateUrl: this.stargateUrl,
            messageId: messageId,
            orgId: this.orgId,
            workspaceId: this.workspaceId
        }, this.coordinationOptions);
    }
    constructor(configOrCloudId, stargateUrl){
        this.cloudId = void 0;
        this.stargateUrl = void 0;
        this.orgId = void 0;
        this.workspaceId = void 0;
        this.coordinationOptions = void 0;
        let config;
        if (typeof configOrCloudId === 'string') config = {
            cloudId: configOrCloudId,
            stargateUrl: stargateUrl,
            isFedRAMPEnvironment: false
        };
        else config = configOrCloudId;
        if (!config.cloudId || !config.stargateUrl) throw new Error('Need a valid CloudId and Stargate url');
        this.cloudId = config.cloudId;
        this.stargateUrl = config.stargateUrl;
        this.orgId = config.orgId;
        this.workspaceId = config.workspaceId;
        this.coordinationOptions = config.coordinationOptions;
    }
}
module.exports["default"] = $4b61f610720049a6$export$2e2bcd8739ae039;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("7xVCs", function(module, exports) {

var $a4TK8 = parcelRequire("a4TK8");


var $T1bCI = parcelRequire("T1bCI");

class $3c23582ca65aa05a$export$90a06df90d015db9 extends (0, $T1bCI.Container) {
    scrollToCurrentPage() {
        this.setState({
            scrollToCurrent: true
        });
    }
    clearScrollTo() {
        this.setState({
            scrollToCurrent: false
        });
    }
    setHighlightPagesIds(pageIds) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(this.state.highlightPagesIds, pageIds)) this.setState({
            highlightPagesIds: pageIds
        });
    }
    clearHighlightedPages() {
        this.setHighlightPagesIds([]);
    }
    setForceFetchPageId(pageId) {
        this.setState({
            forceFetchPageId: pageId
        });
    }
    clearForceFetch() {
        this.setForceFetchPageId(null);
    }
    setOptimisticDeleteId(pageId) {
        this.setState({
            optimisticDeletePageId: pageId
        });
    }
    clearOptimisticDeleteId() {
        this.setOptimisticDeleteId(null);
    }
    setIsEditingTitleId(contentId) {
        return this.setState({
            editingTitle: {
                contentId: contentId
            }
        });
    }
    // This is for content types such as folders that do not have a create content url
    // Instead, we allow naming the content inside the page tree immediately after creation
    forceFetchWithInlineRename(forceFetchId, contentId) {
        this.setState({
            forceFetchPageId: forceFetchId,
            editingTitle: {
                contentId: contentId,
                isNewContent: true
            },
            scrollToPageId: contentId
        });
    }
    clearScrollToPageId() {
        this.setState({
            scrollToPageId: null
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            highlightPagesIds: [],
            forceFetchPageId: null,
            optimisticDeletePageId: null,
            scrollToCurrent: false,
            scrollToPageId: null,
            editingTitle: {
                contentId: null
            }
        };
    }
}
module.exports["PageTreeStateUpdater"] = $3c23582ca65aa05a$export$90a06df90d015db9;

});

parcelRegister("lfBMY", function(module, exports) {
var $93e6e1e47a4562a8$export$64e79c67b77e1326 = /*#__PURE__*/ function(OperationTypes) {
    OperationTypes["USE"] = "use";
    OperationTypes["LIMITED_USE"] = "limited_use";
    OperationTypes["EXTERNAL_COLLABORATOR_USE"] = "external_collaborator_use";
    OperationTypes["CREATE"] = "create";
    OperationTypes["READ"] = "read";
    OperationTypes["UPDATE"] = "update";
    OperationTypes["DELETE"] = "delete";
    OperationTypes["COPY"] = "copy";
    OperationTypes["MOVE"] = "move";
    OperationTypes["EXPORT"] = "export";
    OperationTypes["ARCHIVE"] = "archive";
    OperationTypes["PURGE"] = "purge";
    OperationTypes["PURGE_VERSION"] = "purge_version";
    OperationTypes["ADMINISTER"] = "administer";
    OperationTypes["RESTORE"] = "restore";
    OperationTypes["CREATE_SPACE"] = "create_space";
    OperationTypes["RESTRICT_CONTENT"] = "restrict_content";
    OperationTypes["CLEAR_PERMISSIONS"] = "clear_permissions";
    return OperationTypes;
}({});
module.exports["OperationTypes"] = $93e6e1e47a4562a8$export$64e79c67b77e1326;

});

parcelRegister("2wo33", function(module, exports) {

var $cFXjQ = parcelRequire("cFXjQ");


var $9Z22p = parcelRequire("9Z22p");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $63cta = parcelRequire("63cta");


var $5rZJf = parcelRequire("5rZJf");

const $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    const permittedOperations = operationCheckResult?.content?.nodes?.[0]?.operations ?? [];
    const targetContentType = !!contentType ? contentType : operationCheckResult?.content?.nodes?.[0]?.type;
    if (!targetContentType) return false;
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === targetContentType);
};
const $fec7e6ab8c349d98$export$9df6fd1dd45ee771 = ({ operationCheckResult: operationCheckResult, operation: operation, contentType: contentType })=>{
    // prettier-ignore
    const permittedOperations = operationCheckResult?.space?.operations ?? [];
    return permittedOperations.some((permittedOperation)=>permittedOperation?.operation === operation && permittedOperation?.targetType === contentType);
};
const $fec7e6ab8c349d98$export$e1260b60fe3f2784 = async ({ contentId: contentId, operation: operation, contentType: contentType })=>{
    const contentOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $63cta.ContentOperationsQuery),
        variables: {
            contentId: contentId
        }
    });
    return $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: contentOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$bcbdef0ac5f1ac47 = async ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const spaceOperationsQueryResult = await (0, $c0rhi.queryInterop)({
        query: (0, $5rZJf.SpaceOperationsQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
    return $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: spaceOperationsQueryResult.data,
        operation: operation,
        contentType: contentType
    });
};
const $fec7e6ab8c349d98$export$301dbe403ac05dd5 = ({ contentId: contentId, operation: operation, contentType: contentType, status: status })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $9Z22p.default), {
        variables: {
            contentId: contentId,
            status: status
        }
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$4c9bea4e9a16ccc0({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
const $fec7e6ab8c349d98$export$1fefcc1c89f32022 = ({ spaceKey: spaceKey, operation: operation, contentType: contentType })=>{
    const graphQLResult = (0, $jMyy4.useQueryInterop)((0, $cFXjQ.default), {
        variables: {
            spaceKey: spaceKey
        }
    });
    // Only show the publish button if the user has permission to update (edit) this content.
    let canPerformOperation = undefined;
    if (graphQLResult?.data) canPerformOperation = $fec7e6ab8c349d98$export$9df6fd1dd45ee771({
        operationCheckResult: graphQLResult?.data,
        operation: operation,
        contentType: contentType
    });
    return [
        canPerformOperation,
        graphQLResult
    ];
};
module.exports["canPerformSpaceOperation"] = $fec7e6ab8c349d98$export$9df6fd1dd45ee771;
module.exports["useCanPerformContentOperation"] = $fec7e6ab8c349d98$export$301dbe403ac05dd5;

});

parcelRegister("cFXjQ", function(module, exports) {
/**
 * @generated SignedSource<<c4de1f2f464f7c58da863fcc2b8f8310>>
 * @relayHash 66373ccec9c74286b704fa866e6f85ed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b
const $718578d961a6d231$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "66373ccec9c74286b704fa866e6f85ed",
            "id": "1ee10eaaf4a09a28378f0b27b016e5e12099f96dcd1c9b62be99a779fa6ee76b",
            "metadata": {},
            "name": "entityOperationsHelpersSpaceOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersSpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$718578d961a6d231$var$node.hash = "cc953c6fb5811bde7a3b5ed25712839f";
var $718578d961a6d231$export$2e2bcd8739ae039 = $718578d961a6d231$var$node;
module.exports["default"] = $718578d961a6d231$export$2e2bcd8739ae039;

});

parcelRegister("9Z22p", function(module, exports) {
/**
 * @generated SignedSource<<6c06bb421a64deed65b923b9eaef1fcf>>
 * @relayHash 74ad4c4ef681c6629c8477bfc21dc6ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58
const $16467728a654d6f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "entityOperationsHelpersContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "74ad4c4ef681c6629c8477bfc21dc6ca",
            "id": "e69bbb2b0dd0e8b95fa91edf2f1ffa8bb8da1c6cfb861cc292fe957f3d509a58",
            "metadata": {},
            "name": "entityOperationsHelpersContentOperationsQuery",
            "operationKind": "query",
            "text": "query entityOperationsHelpersContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$16467728a654d6f6$var$node.hash = "a2091cf4018c51963a252c5d39ee0cbc";
var $16467728a654d6f6$export$2e2bcd8739ae039 = $16467728a654d6f6$var$node;
module.exports["default"] = $16467728a654d6f6$export$2e2bcd8739ae039;

});

parcelRegister("63cta", function(module, exports) {

var $8r0lJ = parcelRequire("8r0lJ");

const $bc89d0f4a052c761$export$a42cd9ccc4f06e9e = (0, $8r0lJ.default);
module.exports["ContentOperationsQuery"] = $bc89d0f4a052c761$export$a42cd9ccc4f06e9e;

});

parcelRegister("8r0lJ", function(module, exports) {
/**
 * @generated SignedSource<<db055c87cd42b74d8aeb77e7e48c9c82>>
 * @relayHash afd2c148a694798349dbf7c95e9faf5e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a
const $9494deed8cae7257$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afd2c148a694798349dbf7c95e9faf5e",
            "id": "e41235331832b6af4916acf0b3dea69070b782e8f0b6bcb6aed8527d9e43767a",
            "metadata": {},
            "name": "ContentOperationsQuery",
            "operationKind": "query",
            "text": "query ContentOperationsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$9494deed8cae7257$var$node.hash = "ab356c29a3f1071c83869406e4056f82";
var $9494deed8cae7257$export$2e2bcd8739ae039 = $9494deed8cae7257$var$node;
module.exports["default"] = $9494deed8cae7257$export$2e2bcd8739ae039;

});

parcelRegister("5rZJf", function(module, exports) {

var $3QLqz = parcelRequire("3QLqz");

const $8e7057c5d2ae7999$export$636a01496687d185 = (0, $3QLqz.default);
module.exports["SpaceOperationsQuery"] = $8e7057c5d2ae7999$export$636a01496687d185;

});

parcelRegister("3QLqz", function(module, exports) {
/**
 * @generated SignedSource<<a16e57d7fd38ec5242980bcfc517bf2e>>
 * @relayHash 5ff0445d5306228126745d8454e82696
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6
const $5b7055a8a77b29df$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOperationsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5ff0445d5306228126745d8454e82696",
            "id": "b5af55847710c9021d37adc7a1741b87998b677f5f9dd136a0e2b9050e1c6ea6",
            "metadata": {},
            "name": "SpaceOperationsQuery",
            "operationKind": "query",
            "text": "query SpaceOperationsQuery($spaceKey:String!){space(key:$spaceKey){id,operations{operation,targetType}}}"
        }
    };
}();
$5b7055a8a77b29df$var$node.hash = "c0226693d03f6d30e3056758ad9ba59d";
var $5b7055a8a77b29df$export$2e2bcd8739ae039 = $5b7055a8a77b29df$var$node;
module.exports["default"] = $5b7055a8a77b29df$export$2e2bcd8739ae039;

});

parcelRegister("cQDYl", function(module, exports) {
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e0b2ee147542345d$var$skeletonItemElemSize = 20;
const $e0b2ee147542345d$var$N20A = 'rgba(9, 30, 66, 0.04)';
const $e0b2ee147542345d$var$N30A = 'rgba(9, 30, 66, 0.08)';
const $e0b2ee147542345d$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $e0b2ee147542345d$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $e0b2ee147542345d$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $e0b2ee147542345d$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $e0b2ee147542345d$var$styles.root,
            (hasAvatar || hasIcon) && $e0b2ee147542345d$var$styles.beforeElement,
            hasAvatar && $e0b2ee147542345d$var$styles.avatar,
            hasIcon && $e0b2ee147542345d$var$styles.icon,
            width ? $e0b2ee147542345d$var$styles.customWidth : $e0b2ee147542345d$var$styles.defaultWidth,
            isSideNavSkeleton && $e0b2ee147542345d$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $e0b2ee147542345d$export$2e2bcd8739ae039 = $e0b2ee147542345d$var$SkeletonItem;
module.exports["default"] = $e0b2ee147542345d$export$2e2bcd8739ae039;

});

parcelRegister("7DBey", function(module, exports) {
const $91acf6157f8b5c3c$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $91acf6157f8b5c3c$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $91acf6157f8b5c3c$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};
module.exports["isServiceWithDeps"] = $91acf6157f8b5c3c$export$4094c5185600bd73;
module.exports["unimplementedAbstractService"] = $91acf6157f8b5c3c$export$6e9f7b680f09bab1;
module.exports["toError"] = $91acf6157f8b5c3c$export$cc3b967c039ed3e7;

});

parcelRegister("2Q94g", function(module, exports) {
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $dh538 = parcelRequire("dh538");


var $7DBey = parcelRequire("7DBey");

const $26f4407bbf6764a3$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $26f4407bbf6764a3$export$ddb1688281a3443e = (0, $7DBey.unimplementedAbstractService)('getCurrentCloudId');
const $26f4407bbf6764a3$export$5ebc6cb2748e1881 = (0, $7DBey.unimplementedAbstractService)('getCurrentUserId');
const $26f4407bbf6764a3$export$d01408ed6f850a64 = (0, $7DBey.unimplementedAbstractService)('getCurrentProduct');
const $26f4407bbf6764a3$export$a48841c0475a8073 = (0, $7DBey.unimplementedAbstractService)('createAnalyticsEvent');
const $26f4407bbf6764a3$export$a27c21aa3ed8f0f1 = (0, $7DBey.unimplementedAbstractService)('fireErrorAnalytics');
class $26f4407bbf6764a3$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) {
            super(responseJson.message);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        } else {
            super(`Received error response during action ${action}: ${response.statusText}`);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        }
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
const $26f4407bbf6764a3$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: // Trying to get the status code (404, 500 etc.) from multiple properties
        // because Expansion Services can be used in different environments,
        // which may dependency-inject different fetchJSON() implementations.
        // These throw different FetchError shapes across the main products.
        // Because we're dealing with exceptions, this is not guarded by types.
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $dh538.fg)('puma-1321-expansion-services-event-error-status') && err ? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'responseCode') ?? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'statusCode') ?? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'status') : err instanceof $26f4407bbf6764a3$export$26e841bcf1aeb894 ? err.responseCode : undefined
    });
const $26f4407bbf6764a3$var$getErrorStatusProperty = (error, key)=>{
    const value = error[key];
    if (typeof value === 'number') return value;
};
const $26f4407bbf6764a3$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $26f4407bbf6764a3$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $26f4407bbf6764a3$export$1f2663aaa83f036d = 'Failed to fetch';
const $26f4407bbf6764a3$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $26f4407bbf6764a3$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $26f4407bbf6764a3$export$6827a0909c1bf12f = [
    $26f4407bbf6764a3$export$1f2663aaa83f036d,
    $26f4407bbf6764a3$export$65e55894e6e38a89,
    $26f4407bbf6764a3$export$f25400ad927aa79c
];
const $26f4407bbf6764a3$export$e1b6bb1617649e83 = (errorMessage)=>$26f4407bbf6764a3$export$6827a0909c1bf12f.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $26f4407bbf6764a3$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $26f4407bbf6764a3$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $26f4407bbf6764a3$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $26f4407bbf6764a3$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $26f4407bbf6764a3$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $26f4407bbf6764a3$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $26f4407bbf6764a3$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $26f4407bbf6764a3$export$e089e1d2018847da = 'Default group for the requested resource not found.';
const $26f4407bbf6764a3$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (e) {
        return false;
    }
};
const $26f4407bbf6764a3$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === $26f4407bbf6764a3$export$80a3c1a1eb6f063 || errorMessage === $26f4407bbf6764a3$export$e089e1d2018847da;
const $26f4407bbf6764a3$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $26f4407bbf6764a3$export$678d91a98f79a24d(message, status) || status === 400 && ($26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$c53f16dd5442ef61) || $26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$e27975535396141b)) || status === 412 && $26f4407bbf6764a3$export$395f41a02d6a8be0(key, message);
};
const $26f4407bbf6764a3$export$9de493bcd9b1d977 = 'bad-request';
const $26f4407bbf6764a3$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $26f4407bbf6764a3$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $26f4407bbf6764a3$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $26f4407bbf6764a3$export$e5254cb9f7678ab9) return false;
    return true;
};
module.exports["getStargateURL"] = $26f4407bbf6764a3$export$c7904a8284e43beb;
module.exports["getCurrentCloudId"] = $26f4407bbf6764a3$export$ddb1688281a3443e;
module.exports["getCurrentUserId"] = $26f4407bbf6764a3$export$5ebc6cb2748e1881;
module.exports["getCurrentProduct"] = $26f4407bbf6764a3$export$d01408ed6f850a64;
module.exports["createAnalyticsEvent"] = $26f4407bbf6764a3$export$a48841c0475a8073;
module.exports["getErrorDetails"] = $26f4407bbf6764a3$export$33e83b6fee5d732d;
module.exports["isAcceptableFailure"] = $26f4407bbf6764a3$export$678d91a98f79a24d;
module.exports["isAcceptableFailureForUserInvite"] = $26f4407bbf6764a3$export$1c4c1f7e2d529330;
module.exports["shouldReportFailedInvite"] = $26f4407bbf6764a3$export$90cda429f609d666;

});

parcelRegister("bmTr3", function(module, exports) {

var $7DBey = parcelRequire("7DBey");

const $c1aca408fa9ca14a$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $7DBey.unimplementedAbstractService)('fetchJSON');
module.exports["fetchJSON"] = $c1aca408fa9ca14a$export$81bec6e38e8b706b;

});

parcelRegister("hCOLa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jdJm1 = parcelRequire("jdJm1");

const $5c38ed4eae58ec94$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $42omo.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$5c38ed4eae58ec94$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $jdJm1.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $5c38ed4eae58ec94$var$DIFFERENT = false;
const $5c38ed4eae58ec94$var$EQUAL = true;
const $5c38ed4eae58ec94$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $5c38ed4eae58ec94$var$EQUAL;
    if (!prevObject || !nextObject) return $5c38ed4eae58ec94$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $5c38ed4eae58ec94$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $5c38ed4eae58ec94$var$DIFFERENT;
        }
        return $5c38ed4eae58ec94$var$EQUAL;
    }
};
module.exports["useService"] = $5c38ed4eae58ec94$export$6de4685a6c88b4e9;

});

parcelRegister("jdJm1", function(module, exports) {

var $7DBey = parcelRequire("7DBey");

function $e28c424ef32ed9ff$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $7DBey.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $e28c424ef32ed9ff$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }
module.exports["resolveService"] = $e28c424ef32ed9ff$export$388f24d19a29b0a2;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("8tIbq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $2MPqq = parcelRequire("2MPqq");

const $50e1434d8c6bc030$var$defaultOptions = {
    childList: true,
    subtree: true
};
const $50e1434d8c6bc030$export$6a6a5d23d75b0f62 = ({ selectors: selectors = [
    'body'
], options: options = $50e1434d8c6bc030$var$defaultOptions })=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const { update: update } = popoverContent;
    (0, $42omo.useEffect)(()=>{
        if (!update || selectors.length === 0) return;
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const elements = new Set();
        selectors.forEach((selector)=>{
            const element = doc.querySelector(selector);
            if (!element) return;
            elements.add(element);
        });
        if (elements.size === 0) return;
        const observers = [];
        elements.forEach((element)=>{
            const observer = new MutationObserver((mutations)=>{
                if (mutations.length === 0) return;
                update();
            });
            observer.observe(element, options);
            observers.push(observer);
        });
        return ()=>{
            observers.forEach((observer)=>observer.disconnect());
        };
    }, [
        selectors,
        options,
        update
    ]);
    return null;
};
module.exports["UNSAFE_UpdateOnChange"] = $50e1434d8c6bc030$export$6a6a5d23d75b0f62;

});

parcelRegister("9x2sR", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("fDC7w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6BXcn = parcelRequire("6BXcn");

function $4023ab33a3161118$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4023ab33a3161118$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $42omo.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $42omo.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $dRnqM.default)(element, 'Element ref must be set');
            $4023ab33a3161118$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}
module.exports["useScrollMenuItemIntoView"] = $4023ab33a3161118$export$2c52ec851fcc6058;

});

parcelRegister("6adZX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $059c9f3c8066ba5d$var$initialState = {
    openFlyoutId: null
};
const $059c9f3c8066ba5d$export$3d79379112bcd772 = (0, $1P1Tu.createStore)({
    name: 'FlyoutStore',
    initialState: $059c9f3c8066ba5d$var$initialState,
    actions: {
        openFlyout: (menuId)=>({ setState: setState })=>{
                setState({
                    openFlyoutId: menuId
                });
            },
        closeFlyout: (menuId = null)=>({ setState: setState, getState: getState })=>{
                if (!menuId || menuId === getState().openFlyoutId) setState({
                    openFlyoutId: null
                });
            }
    }
});
const $059c9f3c8066ba5d$export$377168f986312a4 = (0, $9zUhf.createHook)($059c9f3c8066ba5d$export$3d79379112bcd772, {
    selector: (state, menuId)=>state.openFlyoutId === menuId
});
const $059c9f3c8066ba5d$export$3f64b5809402b3ff = (menuId)=>{
    const [isFlyoutOpen, flyoutActions] = $059c9f3c8066ba5d$export$377168f986312a4(menuId);
    const openFlyout = (0, $42omo.useCallback)(()=>flyoutActions.openFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    const closeFlyout = (0, $42omo.useCallback)(()=>flyoutActions.closeFlyout(menuId), [
        flyoutActions,
        menuId
    ]);
    return {
        isFlyoutOpen: isFlyoutOpen,
        openFlyout: openFlyout,
        closeFlyout: closeFlyout
    };
};
const $059c9f3c8066ba5d$export$285f2f1642666795 = (0, $9zUhf.createActionsHook)($059c9f3c8066ba5d$export$3d79379112bcd772);
module.exports["useIsFlyoutOpen"] = $059c9f3c8066ba5d$export$377168f986312a4;
module.exports["useFlyout"] = $059c9f3c8066ba5d$export$3f64b5809402b3ff;
module.exports["useFlyoutActions"] = $059c9f3c8066ba5d$export$285f2f1642666795;

});

parcelRegister("jh864", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8njHX = parcelRequire("8njHX");


var $jvL0g = parcelRequire("jvL0g");

const $bf400a28e0f66299$export$6dc09b7c0ec1dfcd = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, isDisabled: isDisabled, isSelected: isSelected, elemBefore: elemBefore, actionsOnHover: actionsOnHover, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
        ref: listItemRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            elemAfter: elemAfter,
            elemBefore: elemBefore,
            isDisabled: isDisabled,
            /**
					 * Not passing `actions` and `actionsOnHover` to MenuItemBase when `isDisabled`,
					 * so they aren't rendered in the disabled state.
					 */ actions: isDisabled ? undefined : actions,
            actionsOnHover: isDisabled ? undefined : actionsOnHover,
            onClick: onClick,
            ariaControls: ariaControls,
            ariaExpanded: ariaExpanded,
            ariaHasPopup: ariaHasPopup,
            isSelected: isSelected,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ButtonMenuItem"] = $bf400a28e0f66299$export$6dc09b7c0ec1dfcd;

});


//# sourceMappingURL=CreateContentPopover.c022d1a8.js.map
